/* ci-native-cart.js — flag-gated native cart drawer (Rebuy Smart Cart bypass).
   Added 2026-08-25 for the native-vs-Smart-Cart flag test.

   INERT BY DEFAULT. Every behavior below is gated on the html.ci-native-cart
   class (stamped by the inline flag snippet in theme.liquid, or at runtime by
   window.CINativeCart.enable(), which Intelligems variant JS will call).
   Control shoppers: this file only defines window.CINativeCart and attaches
   listeners that early-return. It NEVER touches the product form or the buy
   button — add-to-cart flows through the theme's stock path (global.js ->
   miniCart.renderContents), which already opens the native drawer.

   Suppression is layered (any one alone is enough to keep Smart Cart closed):
   1. CSS: ci-native-cart.css hides #rebuy-cart under the flag class.
   2. rebuy:smartcart.show -> Rebuy.SmartCart.hide() + open native drawer.
   3. Rebuy.SmartCart.skip_open = true (public seam, best-effort). */
(function () {
  'use strict';

  var root = document.documentElement;

  /* 2026-09-22 MONEY IS NEVER ESTIMATED. Ondrej's screen recording, notes
     "decimals" and "flickering discount 30% in cart". The optimistic layer
     used to paint dollar figures before Shopify answered: unit x qty on a
     row, subtotal +/- a delta, the band's "Add $X more" minus a delta, and
     on every add a remembered sale ("Extra 30% OFF applied", learned into
     sessionStorage.ci_promo on 09-02 for the old 30%-off sale) with its
     percentage knocked off the price. That was right while every discount
     was a flat percentage. Under BUY 2, GET 1 FREE (cart-wide, cheapest
     unit of each three) plus codes that win or lose against it, the real
     price is not a function of one line, so every estimate was wrong.
     Measured frame by frame in the recording:
       qty 2->3  band  "Add $21.50"  then  "Add $41"   (bar moved BACKWARD)
       qty 3->4  total "$77.33 $50.67"  then  "$78 $58"
       qty 5->6  band  "Add $0 more", bar full, then "Add $2 more"
       every add "Extra 30% OFF applied" for ~1s, then the real line
     Now: rows, quantities and the pulse still update instantly; every money
     figure keeps its last TRUE value and dims (.ci-money-pending) until the
     server render replaces it, once. Set true to restore the old estimates,
     which is only safe if discounts go back to flat percentages. */
  window.__ciEstimateMoney = false;
  try { sessionStorage.removeItem('ci_promo'); } catch (e) {}

  var api = {
    get enabled() { return root.classList.contains('ci-native-cart'); },
    enable: function () {
      root.classList.add('ci-native-cart');
      applyRebuySeams();
      ensureWidget();
    },
    disable: function () {
      root.classList.remove('ci-native-cart');
    },
    /* 2026-08-28: public open for the PDP upsell's optimistic-add flow
       (fastest-stack variant); defined below, hoisted function. */
    open: function () { return openNativeDrawer(); }
  };
  window.CINativeCart = api;

  /* 2026-09-02 (Ondrej: "track all cart engagement metrics, capture every
     improvement"). ONE tracker for every cart / recommendation event. Sinks:
     GA4 through the store's own gtag (measurement id below, the same one
     Intelligems reports experience_impression to, so arms can be segmented),
     the dataLayer, and Microsoft Clarity. Params are ci_-prefixed, strings
     capped at 100 chars (GA4 limit). Register the ci_* params as event-scoped
     custom dimensions in GA4 admin to see them in reports. */
  var CI_GA4_ID = 'G-MX1XY86PWY';
  function track(evt, extra) {
    try {
      var payload = { ci_arm: 'native', ci_theme: String((window.Shopify && Shopify.theme && Shopify.theme.id) || '') };
      var k;
      if (extra) for (k in extra) {
        if (extra[k] === undefined || extra[k] === null) continue;
        payload[k] = typeof extra[k] === 'number' ? extra[k] : String(extra[k]).slice(0, 100);
      }
      try { window.dataLayer = window.dataLayer || []; var dl = { event: evt }; for (k in payload) dl[k] = payload[k]; window.dataLayer.push(dl); } catch (e1) {}
      try { if (typeof window.gtag === 'function') { var g = {}; for (k in payload) g[k] = payload[k]; g.send_to = CI_GA4_ID; window.gtag('event', evt, g); } } catch (e2) {}
      try { if (typeof window.clarity === 'function') window.clarity('event', evt); } catch (e3) {}
      try { (window.__ciTrackLog = window.__ciTrackLog || []).push([Date.now(), evt, payload]); } catch (e4) {}
    } catch (e) {}
  }
  window.__ciTrack = track;
  /* drawer open / close timing (details toggle does not bubble; capture does) */
  document.addEventListener('toggle', function (e) {
    try {
      var det = e.target;
      if (!det || !det.classList || !det.classList.contains('cart-drawer-container')) return;
      if (det.hasAttribute('open')) { window.__ciCartOpenedAt = Date.now(); }
      else if (window.__ciCartOpenedAt) {
        track('ci_cart_close', { ci_secs_open: Math.round((Date.now() - window.__ciCartOpenedAt) / 1000) });
        window.__ciCartOpenedAt = 0;
      }
    } catch (err) {}
  }, true);

  /* ---------- native drawer open ---------- */
  /* ATC outcome guard (Ondrej approved 2026-08-31). Nothing is bound to the
     buy button itself — the hard rule stands. This only watches the RESULT:
     if a tap does not produce a visible drawer within ~400ms (the panel can
     land in a half-open state where details[open] is set but the closing
     class pins it hidden), close it cleanly and open it again. Never
     re-submits and never touches the add request, so it cannot double-add. */
  function drawerIsVisible() {
    try {
      var panel = document.querySelector('.cart-drawer');
      if (!panel) return false;
      var box = panel.getBoundingClientRect();
      return getComputedStyle(panel).visibility !== 'hidden' &&
             box.width > 0 && box.left < window.innerWidth - 20;
    } catch (e) { return false; }
  }

  function ensureDrawerVisible() {
    var attempts = 0;
    var timer = setInterval(function () {
      attempts++;
      if (drawerIsVisible() || attempts > 12) { clearInterval(timer); return; }
      if (attempts === 4 || attempts === 9) {
        var det = document.querySelector('details.cart-drawer-container');
        var mc = document.querySelector('mini-cart#mini-cart');
        try {
          if (det) {
            det.removeAttribute('open');
            det.classList.remove('menu-opening');
            det.classList.remove('menu-closing');
          }
          document.body.classList.remove('mini-cart--closing');
          document.body.classList.remove('mini-cart--opening');
        } catch (e) {}
        setTimeout(function () {
          if (mc && typeof mc.open === 'function') mc.open();
        }, 30);
      }
    }, 100);
  }

  window.__ciEnsureDrawerVisible = ensureDrawerVisible;

  function openNativeDrawer() {
    var mc = document.querySelector('mini-cart#mini-cart');
    if (mc && typeof mc.open === 'function') {
      mc.open();
      return true;
    }
    var det = document.querySelector('cart-drawer details');
    if (det && !det.hasAttribute('open')) det.setAttribute('open', '');
    return !!det;
  }

  /* ---------- Smart Cart suppression ---------- */
  function applyRebuySeams() {
    if (!api.enabled) return;
    try {
      if (window.Rebuy && Rebuy.SmartCart) Rebuy.SmartCart.skip_open = true;
    } catch (e) {}
  }

  document.addEventListener('rebuy:ready', applyRebuySeams);
  applyRebuySeams();

  /* Rebuy fires smartcart.show as a REFLEX to any /cart/change.js it
     observes (the PDP upsell widget suppresses exactly this in control).
     Translating every show into a native-drawer open made the cart pop open
     when removing an item from the PDP widget (Ondrej 2026-08-26). Only an
     ADD may open the drawer from this path; icon/dock clicks open it
     directly elsewhere. Smart Cart itself always stays hidden. */
  var lastRebuyAddAt = 0;
  document.addEventListener('rebuy:cart.add', function () { lastRebuyAddAt = Date.now(); });

  document.addEventListener('rebuy:smartcart.show', function () {
    if (!api.enabled) return;
    try {
      if (window.Rebuy && Rebuy.SmartCart) Rebuy.SmartCart.hide();
    } catch (e) {}
    if (Date.now() - lastRebuyAddAt < 3000) openNativeDrawer();
  });

  /* Mobile dock cart button: theme.liquid binds it to Rebuy.SmartCart.show().
     Capture-phase interception at the document root runs before any element
     handler; stopImmediatePropagation keeps the Rebuy binding from firing. */
  document.addEventListener('click', function (e) {
    if (!api.enabled) return;
    if (!e.target || !e.target.closest) return;
    var dock = e.target.closest('.dock__item[data-action="cart"]');
    if (dock) {
      e.preventDefault();
      e.stopImmediatePropagation();
      openNativeDrawer();
    }
  }, true);

  /* ---------- Rebuy upsell widget inside the drawer ---------- */
  /* The mini-cart section HTML (with the #ci-cart-upsell slot) is replaced on
     first open (lazy fetch) and on every cart change (renderContents). After
     each replacement the slot div is unmounted, so we re-run Rebuy.init(),
     debounced, only when an unmounted slot is present. */
  /* Widget mounting is a bounded POLL, not event choreography (2026-08-26:
     Ondrej's drawer kept serving without the upsell after every event-based
     fix; one earlier retry even checked a DETACHED slot node from before a
     re-render). Every second: if an unmounted slot exists in the LIVE DOM
     and Rebuy is up, call Rebuy.init(). Runs for 30s after load and restarts
     its window on every drawer open / cart render, so no timing permutation
     escapes. Idle cost: one querySelector per tick, stops when mounted. */
  var mountPollUntil = 0;
  var mountPollTimer = null;
  var initAttempts = 0;
  var mountReported = false;

  function widgetMountTick() {
    if (!api.enabled) return;
    var slot = document.querySelector('#ci-cart-upsell [data-rebuy-id]');
    if (slot && slot.querySelector('[id^="rebuy-widget-"]')) {
      if (!mountReported) { mountReported = true; track('ci_upsell_mounted', { ci_init_attempts: initAttempts }); }
      return;
    }
    mountReported = false;
    if (slot && window.Rebuy && typeof Rebuy.init === 'function') {
      initAttempts++;
      try { Rebuy.init(); } catch (e) {}
      if (initAttempts === 8) track('ci_upsell_mount_stuck', { ci_rebuy_present: true });
    }
    if (Date.now() < mountPollUntil) {
      clearTimeout(mountPollTimer);
      mountPollTimer = setTimeout(widgetMountTick, 1000);
    }
  }

  function ensureWidget() {
    if (!api.enabled) return;
    mountPollUntil = Date.now() + 30000;
    widgetMountTick();
  }
  document.addEventListener('rebuy:ready', ensureWidget);
  if (document.readyState !== 'loading') ensureWidget();
  else document.addEventListener('DOMContentLoaded', ensureWidget);

  /* PREFETCH the drawer content shortly after load (variant only): the
     pending line can only paint into an already-rendered list, and on a
     fresh PDP the theme lazy-fetches the drawer on first open — which made
     instant-open show a spinner instead of the arm-B "item right away"
     (Ondrej 2026-08-26). Reuses the component's own fetch path. */
  /* 2026-08-31 (Ondrej, iPhone private window): on a COLD first tap the
     drawer's lazy fetch was still in flight, so the panel opened showing the
     PRE-ADD cart ("Your cart is empty!" + unstyled empty-state picks) and
     that render wiped the optimistic row. Any add in flight now suppresses
     stale content fetches; the add response renders the real cart. */
  window.__ciPendingAdd = window.__ciPendingAdd || 0;
  function addPending() { return Date.now() - (window.__ciPendingAdd || 0) < 8000; }

  /* A content fetch that was ALREADY in flight when the tap happened cannot
     be cancelled, so its (pre-add) HTML can still land on top of the
     optimistic paint — Ondrej's iPhone recording 2026-08-31 showed the empty
     cart replacing the pending row. Watch the drawer while an add is in
     flight and immediately re-suppress any empty state that appears. */
  (function () {
    var host = null;
    var repainting = false;
    function enforce() {
      if (!addPending() || repainting) return;
      var mc = document.querySelector('.mini-cart');
      if (!mc) return;
      if (mc.classList.contains('is-empty')) mc.classList.remove('is-empty');
      if (!mc.classList.contains('ci-optimistic-pending')) mc.classList.add('ci-optimistic-pending');
      /* A stale (pre-add) render can replace the drawer body and take the
         pending row with it — Ondrej's 18:18 recording showed the empty cart
         appearing where the row had been. Put it back. */
      var html = window.__ciPendingRowHTML;
      if (!html || mc.querySelector('.ci-optimistic-row')) return;
      repainting = true;
      try {
        var ci = mc.querySelector('cart-items');
        var list = ci && ci.querySelector('.mini-cart__navigation');
        if (!list) {
          list = document.createElement('ul');
          list.className = 'mini-cart__navigation ci-optimistic-list';
          var hdr = mc.querySelector('.mini-cart__header');
          if (hdr) hdr.insertAdjacentElement('afterend', list);
          else mc.insertBefore(list, mc.firstChild);
        }
        var holder = document.createElement('div');
        holder.innerHTML = html;
        var node = holder.firstElementChild;
        if (node) {
          list.insertBefore(node, list.firstChild);
          revealRow(node);
        }
      } catch (e) {}
      repainting = false;
    }
    function watch() {
      host = document.getElementById('mini-cart');
      if (!host || host.__ciWatched) return;
      host.__ciWatched = true;
      try {
        new MutationObserver(enforce).observe(host, { childList: true, subtree: true });
      } catch (e) {}
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch);
    else watch();
    document.addEventListener('ci:cart:rerendered', watch);
  })();

  function prefetchDrawer() {
    if (!api.enabled) return;
    if (addPending()) return;
    try {
      var mc = document.querySelector('mini-cart#mini-cart');
      if (!mc || typeof mc.handleIntersection !== 'function') return;
      if (mc.querySelector('.mini-cart__navigation')) return;  /* already loaded */
      mc.handleIntersection([{ isIntersecting: true }], { unobserve: function () {} });
    } catch (e) {}
  }
  if (document.readyState !== 'loading') setTimeout(prefetchDrawer, 1200);
  else document.addEventListener('DOMContentLoaded', function () { setTimeout(prefetchDrawer, 1200); });

  /* 2026-10-13 (Ondrej, iPhone: "both gift and product no photo for a sec" on
     the first add from a PDP or the PDP upsell): the add response paints
     brand-new <img> tags whose files only start downloading then, so the line
     photo and the gift photo sat grey for ~1s. Start those downloads on the
     tap instead: the line photo at the drawer's own size, every gift photo the
     drawer can show, and (PDP adds) the picks pool of the added product, so
     "Others also bought" fills one round trip sooner. The add response takes
     ~0.8s, the small photos ~0.2s. */
  var warmed = {}, warmKeep = [];
  function warmImg(u) {
    if (!u || warmed[u]) return;
    warmed[u] = 1;
    var im = new Image();
    im.src = u;
    warmKeep.push(im);
  }
  window.__ciWarmAdd = function (photo, pid) {
    try {
      if (photo && /[?&]width=\d+/.test(photo)) {
        var dpr = Math.min(3, Math.max(1, Math.round(window.devicePixelRatio || 1)));
        warmImg(photo.replace(/([?&]width=)\d+/, '$1' + (90 * dpr)));
      }
      var gw = document.querySelector('#mini-cart [data-ci-gift-warm]');
      if (gw) gw.getAttribute('data-ci-gift-warm').split(/\s+/).forEach(warmImg);
      var gs = document.querySelector('#mini-cart script[data-ci-gift-state]');
      if (gs) (JSON.parse(gs.textContent).g || []).forEach(function (g) { warmImg(g.i); warmImg(g.m); });
      pid = pid ? String(pid) : '';
      var pc = window.__ciRecsPool;
      if (!pid || (pc && pc.key === pid) || warmed['pool:' + pid]) return;
      warmed['pool:' + pid] = 1;
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      fetch(root + 'recommendations/products.json?product_id=' + encodeURIComponent(pid) + '&limit=10&intent=complementary', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (json) {
          if (!json) return;
          var items = (json.products || []).filter(function (p) { return p && p.handle && p.available !== false; });
          var cur = window.__ciRecsPool;
          if (!(cur && cur.key === pid)) window.__ciRecsPool = { key: pid, items: items, intent: items.length ? 'complementary' : 'related' };
        })
        .catch(function () {});
    } catch (e) {}
  };
  /* Same fix, fallback: when the real render lands before the line photo has
     downloaded, the new <img> shows the optimistic row's photo (same file,
     already on screen) as its background until its own pixels arrive. */
  function underlayLinePhoto(optSrc) {
    try {
      var base = function (u) { return String(u || '').split('?')[0].replace(/^https?:/, ''); };
      var want = base(optSrc);
      document.querySelectorAll('#mini-cart cart-items li img').forEach(function (im) {
        if ((im.complete && im.naturalWidth) || base(im.getAttribute('src')) !== want) return;
        im.style.background = 'url("' + optSrc + '") center / cover no-repeat';
      });
    } catch (e) {}
  }

  /* The theme's cart custom elements re-render sections without emitting any
     event; patch renderContents (drawer-scoped code, NOT the product form) to
     announce it. Guarded so a double-include can't double-patch. */
  function patchRender(tag) {
    var C = customElements.get(tag);
    if (!C || !C.prototype || C.prototype.__ciCartPatched) return;
    var orig = C.prototype.renderContents;
    if (typeof orig !== 'function') return;
    C.prototype.renderContents = function (parsedState) {
      /* renderContents auto-opens the drawer for EVERY render. Control never
         shows that (Smart Cart hides the native drawer), so in the variant it
         surfaced as "cart opens when I remove an item from the PDP widget"
         (Ondrej 2026-08-26). Adds must open; changes/removes must not.
         /cart/add.js responses have no `token`; /cart/change|update.js
         return the FULL cart (token present) — suppress open for those. */
      var optImg = tag === 'mini-cart' && document.querySelector('#mini-cart .ci-optimistic-row img');
      var optSrc = optImg ? (optImg.currentSrc || optImg.src) : '';
      var suppressOpen = api.enabled && parsedState && parsedState.token !== undefined;
      var realOpen = this.open;
      if (suppressOpen && typeof realOpen === 'function') this.open = function () {};
      var r;
      try {
        r = orig.apply(this, arguments);
      } finally {
        if (suppressOpen && typeof realOpen === 'function') this.open = realOpen;
      }
      if (optSrc) underlayLinePhoto(optSrc);
      try {
        document.dispatchEvent(new CustomEvent('ci:cart:rerendered'));
      } catch (e) {}
      return r;
    };
    C.prototype.__ciCartPatched = true;
  }
  ['mini-cart', 'cart-items'].forEach(function (t) {
    if (window.customElements && customElements.whenDefined) {
      customElements.whenDefined(t).then(function () { patchRender(t); }).catch(function () {});
    }
  });

  /* Guard the drawer's lazy-load (2026-08-28): prefetchDrawer calls
     handleIntersection with a FAKE observer, so the element's REAL
     IntersectionObserver stays armed and fires on first open — refetching
     the PRE-add cart over the optimistic paint (Ondrej's show/disappear/
     show flick on first add). Skip the fetch whenever drawer content
     already exists. */
  function patchLazyLoad() {
    var C = customElements.get('mini-cart');
    if (!C || !C.prototype || C.prototype.__ciLazyPatched) return;
    var orig = C.prototype.handleIntersection;
    if (typeof orig !== 'function') return;
    C.prototype.handleIntersection = function (entries, observer) {
      if (entries && entries[0] && !entries[0].isIntersecting) return;
      if (addPending()) {           /* stale pre-add cart would flash */
        try { if (observer && observer.unobserve) observer.unobserve(this); } catch (e) {}
        return;
      }
      if (this.querySelector('.mini-cart__navigation') ||
          this.querySelector('.ci-optimistic-shell') ||
          this.querySelector('.mini-cart')) {
        try { if (observer && observer.unobserve) observer.unobserve(this); } catch (e) {}
        return;
      }
      /* 2026-09-02: the original fetch cannot be cancelled, so a tap that
         lands while the prefetch is in flight got the PRE-add cart painted
         over its optimistic row/bump ~1s later (merge path: qty 3 -> 2 -> 3).
         Same fetch, but the response is dropped when an add is pending or a
         real render has landed meanwhile; the add's own render (or the
         reconcile refresh) supplies the content instead. */
      try { if (observer && observer.unobserve) observer.unobserve(this); } catch (e) {}
      var self = this;
      var startedAt = Date.now();
      fetch(this.dataset.url)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          if (addPending()) return;
          if (window.__ciLastRenderAt && window.__ciLastRenderAt > startedAt) return;
          if (self.querySelector('.mini-cart__navigation') || self.querySelector('.mini-cart')) return;
          var host = document.getElementById('mini-cart');
          if (!host) return;
          host.innerHTML = self.getSectionInnerHTML(html, '.shopify-section');
          document.dispatchEvent(new CustomEvent('cartdrawer:opened'));
        })
        .catch(function () {});
    };
    C.prototype.__ciLazyPatched = true;
  }
  /* 2026-09-02: patching after whenDefined() is too late for the element's
     OWN IntersectionObserver: connectedCallback runs during define() and
     binds the ORIGINAL handleIntersection, so the first time the drawer
     became visible that bound original fetched the pre-add cart and stomped
     the optimistic totals (subtotal 366.10 -> 0.00 -> 366.10, measured on
     both mobile and desktop). This script is a deferred head script and
     cart-drawer.js is a deferred body script, so it runs first: wrap
     customElements.define and patch the prototype BEFORE registration. The
     whenDefined path stays as the fallback for any other load order. */
  try {
    if (window.customElements && !customElements.__ciDefineWrapped) {
      var origDefine = customElements.define.bind(customElements);
      customElements.define = function (name, ctor, opts) {
        if (name === 'mini-cart' && ctor && ctor.prototype && !ctor.prototype.__ciLazyPatched) {
          var orig = ctor.prototype.handleIntersection;
          if (typeof orig === 'function') {
            ctor.prototype.handleIntersection = function (entries, observer) {
              if (entries && entries[0] && !entries[0].isIntersecting) return;
              try { if (observer && observer.unobserve) observer.unobserve(this); } catch (e) {}
              if (addPending()) return;
              if (this.querySelector('.mini-cart__navigation') ||
                  this.querySelector('.ci-optimistic-shell') ||
                  this.querySelector('.mini-cart')) return;
              var self = this;
              var startedAt = Date.now();
              fetch(this.dataset.url)
                .then(function (r) { return r.text(); })
                .then(function (html) {
                  if (addPending()) return;
                  if (window.__ciLastRenderAt && window.__ciLastRenderAt > startedAt) return;
                  if (self.querySelector('.mini-cart__navigation') || self.querySelector('.mini-cart')) return;
                  var host = document.getElementById('mini-cart');
                  if (!host) return;
                  host.innerHTML = self.getSectionInnerHTML(html, '.shopify-section');
                  document.dispatchEvent(new CustomEvent('cartdrawer:opened'));
                })
                .catch(function () {});
            };
            ctor.prototype.__ciLazyPatched = true;
          }
        }
        return origDefine(name, ctor, opts);
      };
      customElements.__ciDefineWrapped = true;
    }
  } catch (e) {}
  if (window.customElements && customElements.whenDefined) {
    customElements.whenDefined('mini-cart').then(patchLazyLoad).catch(function () {});
  }

  /* ---------- Smart Cart parity retexts (2026-08-26) ---------- */
  /* The native drawer must read like the control Smart Cart so the test
     isolates the engine, not the copy. All writes are value-guarded so
     re-running on every render is a no-op. Reference strings measured off
     the live control cart 2026-08-26. */
  function applyParityText() {
    if (!api.enabled) return;
    try {
      var title = document.querySelector('.mini-cart__header .title');
      if (title && !/^Your cart/i.test(title.textContent.trim())) title.textContent = 'Your cart'; /* V4 2026-09-18: Liquid renders "Your cart (N)"; only a foreign title gets replaced */

      /* "Spend X more to reach free shipping" -> "You are X away from FREE
         SHIPPING!", keeping the theme's own <price-money> node for the
         amount so currency formatting stays correct. Success state keeps
         the native congratulations line. */
      /* 2026-09-22 unlock moment (Spark run): the celebration marks CROSSING
         $79, not every render. The drawer rebuilds this node on any qty
         change, so a bare CSS animation would replay the spark each time a
         shopper edits an already-qualifying cart. Stamp the class only on a
         locked -> unlocked transition; a cart that is ALREADY unlocked the
         first time we see it is recorded silently, never celebrated. State
         hangs off window because this file is several IIFEs. */
      var ciBand = document.querySelector('.mini-cart .free-shipping');
      var ciOk = document.querySelector('.mini-cart .free-shipping.ci-fs--ok');
      if (ciOk) {
        if (window.__ciFsUnlocked === false) ciOk.classList.add('ci-fs--celebrate');
        window.__ciFsUnlocked = true;
      } else if (ciBand) {
        window.__ciFsUnlocked = false;
      }

      var fs = document.querySelector('.mini-cart .free-shipping__text:not(.free-shipping__text--success)');
      if (fs && !fs.hasAttribute('data-ci-retexted')) {
        var money = fs.querySelector('price-money');
        if (money) {
          var amountHTML = money.outerHTML;
          /* Parity 2026-08-28: control's Smart Cart countdown phrasing. */
          fs.innerHTML = 'You are ' + amountHTML + ' away from <b>FREE SHIPPING</b>!';
        }
        fs.setAttribute('data-ci-retexted', '1');
      }
      /* Success state: control says "🎉 Congrats! You've unlocked FREE
         SHIPPING!" (captured off the live control 2026-08-27). */
      var fsOk = document.querySelector('.mini-cart .free-shipping__text--success');
      if (fsOk && !fsOk.hasAttribute('data-ci-retexted')) {
        fsOk.innerHTML = '🎉 Congrats! You’ve unlocked <b>FREE SHIPPING!</b>';
        fsOk.setAttribute('data-ci-retexted', '1');
      }

      /* "Subtotal" -> "Subtotal (N items)" with N from the drawer's qty
         inputs (the same numbers the section just rendered). */
      var label = document.querySelector('.mini-cart .subtotal .label');
      /* 2026-10-09 gift arm: footer A renders "Subtotal" + "N items" itself (.ci-fa-row); never flatten it */
      if (label && !document.querySelector('.mini-cart .ci-fa-row')) {
        var n = 0;
        document.querySelectorAll('.mini-cart__navigation .quantity__input').forEach(function (i) {
          n += parseInt(i.value, 10) || 0;
        });
        var want = 'Subtotal (' + n + (n === 1 ? ' item' : ' items') + ')';
        /* V4 2026-09-18: the header already carries the count ("Your cart (N)"),
           so the subtotal label stays plain and the line fits with the pill */
        if (document.querySelector('.mini-cart.ci-cart-v4')) want = 'Subtotal';
        if (n > 0 && label.textContent.trim() !== want) label.textContent = want;
      }

      /* CTA carries no total (2026-08-31 parity): nothing to retext. */

      /* The shop money format prints "$ 56" (space after a LEADING symbol);
         control renders "$56". Trailing symbols (THB ฿) get exactly one
         space, matching control's "399.00 ฿". */
      document.querySelectorAll('.mini-cart price-money bdi').forEach(function (b) {
        var h = b.innerHTML;
        var fixed = h.replace(/^(\s*<span class="price__prefix">[^<]*<\/span>)\s+/, '$1');
        fixed = fixed.replace(/\s*(<span class="price__prefix">[^<]*<\/span>)\s*$/, '$1');
        if (fixed !== h) b.innerHTML = fixed;
      });

      /* Learn the automatic discount from rendered lines so the next optimistic
         row can paint the same SALE line and discounted price on first paint.
         Off while window.__ciEstimateMoney is false (see the top of file). */
      if (window.__ciEstimateMoney === true) try {
        var learned = null;
        try { learned = JSON.parse(sessionStorage.getItem('ci_promo') || 'null') || {}; } catch (le) { learned = {}; }
        learned.handles = learned.handles || {};
        var changed = false;
        document.querySelectorAll('.mini-cart cart-items li[data-handle]').forEach(function (li) {
          var d = li.querySelector('.discounts__discount');
          var t = d ? d.textContent.replace(/\s+/g, ' ').trim() : '';
          var pmm = t.match(/(\d{1,2})\s*%\s*off/i);
          if (!pmm) return;
          if (learned.title !== t || learned.pct !== parseInt(pmm[1], 10)) { learned.title = t; learned.pct = parseInt(pmm[1], 10); changed = true; }
          var h = li.getAttribute('data-handle');
          if (h && !learned.handles[h]) { learned.handles[h] = 1; changed = true; }
        });
        if (changed) sessionStorage.setItem('ci_promo', JSON.stringify(learned));
      } catch (e5) {}

      /* Empty state: mirror the control Smart Cart's empty_cart_markup
         (copied from the Rebuy config 2026-08-26 — re-sync if it changes). */
      var emptyBox = document.querySelector('.mini-cart.is-empty .mini-cart__empty');
      if (emptyBox && !emptyBox.hasAttribute('data-ci-parity')) {
        emptyBox.innerHTML =
          '<h4 class="ci-empty-title">Your cart is empty!</h4>' +
          '<p class="ci-empty-text">Add your favorite items to your cart.</p>' +
          '<p class="ci-empty-link"><a href="/collections/all">Shop Now</a></p>';
        emptyBox.setAttribute('data-ci-parity', '1');
      }
    } catch (e) {}
  }

  function onCartRendered() {
    ensureWidget();
    applyParityText();
    /* 2026-09-02: the upsell widget announces the render before its section
       swap has fully settled, so the "(N items)" count was missing on that
       path; one deferred pass is value-guarded and cheap. */
    setTimeout(applyParityText, 80);
    setTimeout(applyParityText, 500);
    setTimeout(applyParityText, 1500);
  }

  /* 2026-09-02: the theme's own cart.js re-renders the free-shipping bar and
     line list on qty changes without firing our events, which put the stock
     "You are eligible for free shipping." back (Ondrej's screenshot). Watch
     the drawer subtree and re-apply the value-guarded parity pass. */
  (function () {
    var host = document.getElementById('mini-cart');
    if (!host || typeof MutationObserver !== 'function') return;
    var t = null;
    new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(applyParityText, 40);
    }).observe(host, { childList: true, subtree: true });
  })();
  document.addEventListener('cartdrawer:opened', onCartRendered);     /* first lazy fetch */
  document.addEventListener('ci:cart:rerendered', onCartRendered);    /* ATC / qty updates */
  document.addEventListener('rebuy:cart.change', ensureWidget);       /* rebuy-side changes */

  /* ---------- drawer refresh on Rebuy-originated cart changes ---------- */
  /* Adds from the upsell widget run through Rebuy's pipeline and bypass the
     theme's renderContents, leaving the drawer stale (found in QA 2026-08-25:
     cart.js said 2 items, drawer showed 1). Refresh the cart sections via the
     Section Rendering API. Theme-side renders mark lastThemeRender so a
     native qty/remove/ATC (which Rebuy's fetch-watcher also reports as
     rebuy:cart.change) does not trigger a redundant second fetch. */
  var refreshTimer = null;
  var lastThemeRender = 0;

  /* Only THEME-sourced renders (renderContents patch) count as "already
     fresh"; our own refresh dispatches with detail.source='refresh' so a
     rapid second widget add still gets its refresh. Our ?sections= GET is not
     a cart mutation, so Rebuy's fetch-watcher never reports it and there is
     no self-loop. */
  document.addEventListener('ci:cart:rerendered', function (e) {
    if (e.detail && e.detail.source === 'refresh') return;
    lastThemeRender = Date.now();
    clearTimeout(refreshTimer);
  });

  var lastRefreshStart = 0;

  function scheduleRefresh(delayMs) {
    if (!api.enabled) return;
    if (Date.now() - lastThemeRender < 1200) return;   /* theme just rendered */
    if (Date.now() - lastRefreshStart < 1200) return;  /* refresh already running */
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(doRefresh, typeof delayMs === 'number' ? delayMs : 600);
  }

  function doRefresh(isRetry) {
    lastRefreshStart = Date.now();
    var ids = ['mini-cart', 'cart-icon-bubble', 'mobile-cart-icon-bubble'];
    var rootPath = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(rootPath + '?sections=' + ids.join(','))
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        ids.forEach(function (id) {
          var target = document.getElementById(id);
          var html = sections[id];
          if (!target || !html) return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var inner = doc.querySelector('.shopify-section');
          if (inner) target.innerHTML = inner.innerHTML;
        });
        document.dispatchEvent(new CustomEvent('ci:cart:rerendered', { detail: { source: 'refresh' } }));
      })
      .catch(function () {
        /* 2026-09-02: a refresh that fails (rate limit, blip) would leave the
           optimistic numbers on screen with nothing to reconcile them; one
           retry covers the transient case. */
        if (!isRetry) setTimeout(function () { doRefresh(true); }, 2500);
      });
  }
  window.__ciDrawerRefresh = doRefresh;

  /* 2026-09-02 reliability pass (Ondrej): the optimistic layer paints on top
     of whatever the drawer currently shows, so a STALE drawer (back from
     checkout via bfcache, cart edited in another tab, a failed request) makes
     the optimistic math visibly wrong until the next real render. Re-pull
     the drawer sections when the page is restored from bfcache, and when the
     tab becomes visible again after more than a minute without a render. */
  window.__ciLastRenderAt = Date.now();
  document.addEventListener('ci:cart:rerendered', function () { window.__ciLastRenderAt = Date.now(); });
  document.addEventListener('cartdrawer:opened', function () { window.__ciLastRenderAt = Date.now(); });
  window.addEventListener('pageshow', function (e) {
    try { if (e.persisted && api.enabled && !addPending()) doRefresh(); } catch (err) {}
  });
  document.addEventListener('visibilitychange', function () {
    try {
      if (document.visibilityState === 'visible' && api.enabled && !addPending() &&
          Date.now() - window.__ciLastRenderAt > 60000) doRefresh();
    } catch (err) {}
  });

  /* rebuy:cart.add fires at the add response (~900ms before cart.change):
     refresh immediately so a widget add lands in the drawer in one fetch
     round-trip. cart.change stays as the debounced catch-all. */
  document.addEventListener('rebuy:cart.add', function () { scheduleRefresh(0); });
  document.addEventListener('rebuy:cart.change', function () { scheduleRefresh(600); });

  /* ---------- instrumentation ---------- */
  /* Drawer open: <details> fires a non-bubbling toggle; listen in capture. */
  document.addEventListener('toggle', function (e) {
    if (!api.enabled) return;
    var det = e.target;
    if (det && det.classList && det.classList.contains('cart-drawer-container') && det.hasAttribute('open')) {
      track('ci_cart_open', { ci_items: document.querySelectorAll('.mini-cart cart-items li').length });
      ensureWidget();
    }
  }, true);

  /* Upsell ATC: any click on the widget's own ADD button inside our slot.
     Rebuy's button does the actual add (preserving its attribution); we paint
     an OPTIMISTIC pending line immediately (add.js TTFB is ~1-1.5s on this
     store and the sections refresh another ~1.5s — without this the add feels
     dead for ~3s). The pending line is display-only (pointer-events:none) and
     the next full render replaces the list wholesale, so reconciliation is
     automatic; a 10s timer sweeps it if the refresh never lands. */
  function paintPendingLine(imgSrc, titleText, priceText, compareText, extra) {
    try {
      if (window.__ciWarmAdd) window.__ciWarmAdd(imgSrc);
      var list = document.querySelector('.mini-cart__navigation');
      if (!list || !titleText) return;
      /* 2026-09-02 (Ondrej: SALE line missing during the flicker on widget adds):
         same rules as the PDP form path. Sale eligibility rides on the card
         (data-ci-sale), the discount title/pct is the one learned from rendered
         lines; discounted price only next to a compare-at (theme rule). */
      extra = extra || {};
      var promoLine = '', optionLine = '';
      try {
        var rc = window.__ciEstimateMoney === true ? (JSON.parse(sessionStorage.getItem('ci_promo') || 'null') || window.__ciPromoDefault || null) : null;
        if (extra.sale && rc && rc.title) {
          promoLine = '<ul class="discounts list-unstyled" role="list" aria-label="Discount"><li class="discounts__discount">' + String(rc.title).replace(/</g, '&lt;') + '</li></ul>';
          var pct = parseInt(rc.pct, 10) || 0;
          var m0 = compareText && priceText ? priceText.match(/[0-9][0-9.,]*/) : null;
          if (pct > 0 && pct < 100 && m0) {
            var base = parseFloat(m0[0].replace(/,/g, '')) || 0;
            if (base) {
              var parts = (base * (1 - pct / 100)).toFixed(2).split('.');
              parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
              priceText = priceText.replace(m0[0], parts.join('.'));
            }
          }
        }
        if (extra.option) optionLine = '<dl><div class="product-option"><dd>' + String(extra.option).replace(/</g, '&lt;') + '</dd></div></dl>';
      } catch (pe) {}
      /* money waits for the server render (top of file) */
      if (window.__ciEstimateMoney !== true) { priceText = ''; compareText = ''; }
      var dup = Array.prototype.some.call(
        list.querySelectorAll('.ci-optimistic-line .product-title'),
        function (t) { return t.textContent.trim() === titleText; }
      );
      if (dup) return;
      var li = document.createElement('li');
      /* 2026-08-31 (Ondrej): this line used a hardcoded 70px thumb while real
         rows render 90px, so an upsell add flickered in at the wrong size.
         Use the same classes/structure as a real line item and let the
         reskin size it; pulse like every other optimistic paint. */
      li.className = 'ci-optimistic-line ci-optimistic-row ci-opt-pulse';
      li.style.cssText = 'pointer-events:none;';
      li.innerHTML =
        '<div class="product-container">' +
          (imgSrc ? '<div><span class="product-image media-wrapper media-wrapper--small"><img src="' + imgSrc + '" alt="" style="width:100%;display:block;"></span></div>' : '') +
          '<div class="product-description"><div class="product-content">' +
            '<span class="link product-title">' + titleText + '</span>' +
          '</div>' + optionLine + promoLine +
          '<div class="product-quantity">' +
            '<dt><quantity-input class="quantity">' +
              '<button class="quantity__button" type="button" disabled aria-hidden="true">&minus;</button>' +
              '<input class="quantity__input" type="text" value="1" readonly aria-label="Quantity">' +
              '<button class="quantity__button" type="button" disabled aria-hidden="true">&#43;</button>' +
            '</quantity-input></dt>' +
            /* 2026-09-02: identical price markup to the rendered line (dl/dd/s/igPrice), so nothing moves on confirm */
            ((compareText) ? '<dl class="cart-item__discounted-prices"><dt class="visually-hidden">Regular price</dt><dd class="price--on-sale"><s class="price price-item--regular igComparePrice"><price-money><bdi>' + (compareText) + '</bdi></price-money></s></dd><dt class="visually-hidden">Sale price</dt><dd class="price igPrice"><price-money><bdi>' + ((priceText || '')) + '</bdi></price-money></dd></dl>' : '<dd class="price igPrice"><price-money><bdi>' + ((priceText || '')) + '</bdi></price-money></dd>') +
          '</div></div>' +
          '<cart-remove-button><span class="delete-product" aria-hidden="true"></span></cart-remove-button>' +
        '</div>';
      list.insertBefore(li, list.firstChild);
      setTimeout(function () { if (li.parentNode) li.parentNode.removeChild(li); }, 10000);
      var empty = document.querySelector('.mini-cart.is-empty');
      if (empty) empty.classList.remove('is-empty');
    } catch (e) {}
  }

  function paintOptimisticLine(btn) {
    try {
      var card = btn.closest('.rebuy-product-block');
      if (!card) return;
      var img = card.querySelector('.rebuy-product-media img');
      var title = card.querySelector('.rebuy-product-title');
      var price = card.querySelector('.rebuy-money.sale') || card.querySelector('.rebuy-money');
      paintPendingLine(img && img.src, title && title.textContent.trim(), price && price.textContent.trim());
    } catch (e) {}
  }

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    if (!api.enabled) return;
    var btn = e.target.closest('#ci-cart-upsell .rebuy-button');
    if (btn) {
      track('ci_upsell_atc');
      paintOptimisticLine(btn);
    }
  }, true);

  /* Arm-B behavior for the PDP "Complete the ritual" widget (Ondrej
     2026-08-26): checking a card opens the cart IMMEDIATELY with a pending
     line, not after the add round-trip. Checkbox state at event time is the
     post-toggle state, so checked === add; removes never open. The label
     click re-dispatches onto the input, so the handler is idempotent
     (open() no-ops when open, paintPendingLine dedups by title). */
  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    if (!api.enabled) return;
    var box = e.target.closest('.product-upsell__checkbox');
    if (!box && e.target.closest('label')) {
      var lbl = e.target.closest('label');
      var forEl = lbl.htmlFor ? document.getElementById(lbl.htmlFor) : lbl.querySelector('.product-upsell__checkbox');
      if (forEl && forEl.classList && forEl.classList.contains('product-upsell__checkbox')) box = forEl;
    }
    if (!box) return;
    setTimeout(function () {
      if (!box.checked) return;
      openNativeDrawer();
      track('ci_pdp_upsell_open');
      try {
        /* card anatomy: input sits INSIDE label.product-upsell__card (a
           [class*=product-upsell] closest() matches the input itself). */
        var card = box.closest('.product-upsell__card') || box.parentElement;
        var img = card && card.querySelector('img');
        var titleEl = card && card.querySelector('.product-upsell__title');
        /* 2026-08-31 (Ondrej, THB screenshot): the old "last whitespace
           token" trick returned just the currency symbol for trailing-symbol
           currencies ("404.00 ฿" -> "฿"), so the pending row showed a lone
           red ฿. Read the price ELEMENT instead. */
        var priceEl = card && (
          card.querySelector('.product-upsell__price--sale') ||
          card.querySelector('[data-upsell-price]') ||
          card.querySelector('.product-upsell__price')
        );
        var priceText = priceEl ? priceEl.textContent.replace(/\s+/g, ' ').trim() : '';
        if (!priceText && card) {
          var grp = card.querySelector('.product-upsell__price-group');
          var m = grp && grp.textContent.replace(/\s+/g, ' ').match(/[^\s]*\d[\d.,]*\s?[^\s\d]*/g);
          if (m && m.length) priceText = m[m.length - 1].trim();
        }
        /* The title node contains a nested "More info" toggle whose text
           leaked into the pending line (Ondrej 2026-08-31). Clone, drop
           interactive children, then read the text. */
        var titleText = '';
        if (titleEl) {
          /* 2026-08-31 v2: stripping every <a> emptied the title (the title
             ITSELF is a link) and the pending line silently stopped
             painting. Drop only the "More info" affordance, then fall back
             to the raw text with that label trimmed. */
          var clean = function (t) {
            return String(t || '').replace(/\s+/g, ' ').replace(/\s*More info\s*$/i, '').trim();
          };
          var clone = titleEl.cloneNode(true);
          clone.querySelectorAll('[class*="more-info"], [class*="moreInfo"], .visually-hidden').forEach(function (n) { n.remove(); });
          titleText = clean(clone.textContent) || clean(titleEl.textContent);
        }
        /* Ondrej 2026-08-31: "show the price the same way as the main ATC" —
           that row renders red sale + struck compare-at, so the upsell row
           must carry the compare price too. */
        var compareEl = card && card.querySelector('.product-upsell__price--compare');
        var compareText = compareEl ? compareEl.textContent.replace(/\s+/g, ' ').trim() : '';
        paintPendingLine(
          img && (img.currentSrc || img.src),
          titleText,
          priceText,
          compareText,
          { sale: box.getAttribute('data-ci-sale') === '1', option: box.getAttribute('data-variant-title') || '' }
        );
      } catch (err) {}
    }, 0);
  }, true);

  /* ---------- boot ---------- */
  if (api.enabled) {
    track('ci_cart_exposure');
    applyRebuySeams();
  }
})();


/* ---------- OPTIMISTIC ATC v2 (2026-08-28, Ondrej) ----------
   Open the drawer and paint the added item the moment the buy button is
   pressed. v2: the painted row is a structural CLONE of a real line item
   (same classes -> same reskin styling: 90px image, underlined title,
   variant line, stepper, trash, red price + struck compare read off the
   PDP), so the real render replaces it without any visible morph. Also
   covers the empty-cart path (is-empty removed, row anchored after the
   header when no list exists yet). The theme's real submit flow is never
   touched; a failure here can never break the add. */
(function () {
  /* tracker lives in the first IIFE; alias it here so a call can never throw inside the optimistic paint */
  var track = function () { try { if (window.__ciTrack) window.__ciTrack.apply(null, arguments); } catch (e) {} };
  var WATCHDOG_MS = 9000;
  var pendingTimer = null;
  function cleanup() {
    if (window.__ciPendingAdd && !window.__ciReconciling) track('ci_cart_add_confirmed', { ci_ms: Date.now() - window.__ciPendingAdd });
    window.__ciPendingAdd = 0;
    window.__ciPendingRowHTML = null;
    document.querySelectorAll('.ci-optimistic-row, .ci-optimistic-list').forEach(function (n) { n.remove(); });
    document.querySelectorAll('.ci-opt-pulse, .ci-opt-removing, .ci-opt-qtying').forEach(function (n) {
      n.classList.remove('ci-opt-pulse');
      n.classList.remove('ci-opt-removing');
      n.classList.remove('ci-opt-qtying');
    });
    var m = document.querySelector('.mini-cart.ci-optimistic-pending');
    if (m) m.classList.remove('ci-optimistic-pending');
  }
  document.addEventListener('ci:cart:rerendered', function () { clearTimeout(pendingTimer); cleanup(); });

  /* ---- 2026-09-02 reliability pass: never leave a lie on screen ----
     Before this, a failed add (network drop, a 429 from Shopify, a sold-out
     422) left the painted row pulsing for 12s and then silently removed it,
     with the subtotal / item count still carrying the optimistic delta. Now
     every failure signal (theme pubsub cart-error, the recs element's
     ajaxProduct:error, or simply no render inside 9s) clears the optimistic
     layer, re-pulls the real drawer, and says so in one line. */
  function showNote(msg) {
    try {
      var mc = document.querySelector('.mini-cart');
      if (!mc) return;
      var old = mc.querySelector('.ci-cart-note');
      if (old) old.remove();
      var n = document.createElement('div');
      n.className = 'ci-cart-note';
      n.setAttribute('role', 'status');
      n.textContent = msg;
      var hdr = mc.querySelector('.mini-cart__header');
      if (hdr && hdr.parentNode) hdr.insertAdjacentElement('afterend', n);
      else mc.insertBefore(n, mc.firstChild);
      setTimeout(function () { if (n.parentNode) n.remove(); }, 5000);
    } catch (e) {}
  }
  function reconcile(msg) {
    clearTimeout(pendingTimer);
    window.__ciReconciling = true;
    cleanup();
    window.__ciReconciling = false;
    track('ci_cart_error', { ci_msg: msg || '', ci_pending: window.__ciPendingAdd ? 1 : 0 });
    try { if (window.__ciDrawerRefresh) window.__ciDrawerRefresh(); } catch (e) {}
    if (msg) showNote(msg);
  }
  window.__ciReconcile = reconcile;
  function armWatchdog() {
    clearTimeout(pendingTimer);
    pendingTimer = setTimeout(function () {
      if (window.__ciPendingAdd) reconcile("Your cart didn't update. Please try again.");
    }, WATCHDOG_MS);
  }
  try {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartError, function (d) {
        var m = d && (d.message || (typeof d.errors === 'string' ? d.errors : ''));
        reconcile(m || "That item couldn't be added.");
      });
    }
  } catch (e) {}
  document.addEventListener('ajaxProduct:error', function (e) {
    var m = e && e.detail && e.detail.errorMessage;
    reconcile(m || "That item couldn't be added.");
  });
  (function watchSubmitButtons() {
    if (typeof MutationObserver === 'undefined') return;
    function check(btn) {
      if (!window.__ciPendingAdd) return;
      if (btn.classList.contains('loading')) return;
      setTimeout(function () {
        if (!window.__ciPendingAdd) return;
        if (Date.now() - (window.__ciLastRenderAt || 0) < 700) return;   /* a render landed: success */
        if (btn.classList.contains('loading')) return;
        reconcile("Your cart didn't update. Please try again.");
      }, 250);
    }
    try {
      new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) {
          var t = muts[i].target;
          if (t && t.classList && t.classList.contains('product-form__submit')) check(t);
        }
      }).observe(document.documentElement, { subtree: true, attributes: true, attributeFilter: ['class'] });
    } catch (e) {}
  })();

  /* Ondrej 2026-08-31: "the flicker often does not happen" — when the product
     is ALREADY in the cart we bump that row instead of painting a new one,
     and in a long cart that row can sit below the fold, so the feedback was
     invisible. Bring whatever we touched into view. */
  function revealRow(el) {
    if (!el) return;
    setTimeout(function () {
      try {
        var scroller = el.closest('.mini-cart__main') ||
                       el.closest('[style*="overflow"]') ||
                       document.querySelector('.mini-cart__main');
        if (scroller && scroller.scrollHeight > scroller.clientHeight) scroller.scrollTop = 0;
        if (typeof el.scrollIntoView === 'function') {
          el.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
        }
      } catch (e) {}
    }, 60);
  }

  function ciOptimisticAdd(form) {
    try {
      if (!(form instanceof HTMLFormElement)) return;
      if ((form.getAttribute('action') || '').indexOf('/cart/add') === -1) return;
      if (!document.documentElement.classList.contains('ci-native-cart')) return;
      /* 2026-09-02: the click listener AND the submit listener both reach here
         for one tap (by design, see below), and the MERGE path had no guard,
         so an existing line was bumped twice (qty 2 -> 4 for a single add,
         corrected ~1s later by the render). One paint per form per tap; and
         nothing while the theme still has the button in its loading state. */
      var now = Date.now();
      if (window.__ciLastOptForm === form && now - (window.__ciLastOptAt || 0) < 1500) return;
      if (form.querySelector('[type="submit"].loading')) return;
      window.__ciLastOptForm = form;
      window.__ciLastOptAt = now;
      window.__ciPendingAdd = now;
      var api = window.CINativeCart;
      if (api && api.open) api.open();
      /* defined in the cart-api IIFE above; call through window so a scope
         miss can never abort the optimistic paint (it did on 2026-08-31). */
      if (typeof window.__ciEnsureDrawerVisible === 'function') window.__ciEnsureDrawerVisible();
      var mc = document.querySelector('.mini-cart');
      if (mc && mc.querySelector('.ci-optimistic-row')) return;
      if (!mc) {
        /* Pre-prefetch state: the mini-cart container is still EMPTY (its
           content lazy-loads ~1.2s after page load), so a fast tap opened a
           bare shell with nothing to paint into — Ondrej's "item pops in
           later". Build a minimal drawer (header + list) with the real
           classes; the add-response render replaces it wholesale. */
        var host = document.getElementById('mini-cart');
        if (!host) return;
        host.innerHTML =
          '<div class="mini-cart ci-optimistic-shell">' +
            '<div class="mini-cart__header"><div class="title h4">Your cart</div></div>' +
          '</div>';
        mc = host.querySelector('.mini-cart');
      }

      var vid = parseInt((form.querySelector('[name="id"]') || {}).value, 10);
      var qty = parseInt(((form.querySelector('[name="quantity"]') || {}).value) || '1', 10) || 1;
      var meta = (window.ShopifyAnalytics && window.ShopifyAnalytics.meta) || {};
      track('ci_cart_add', {
        ci_source: form.closest('product-upsell') ? 'pdp_upsell' : (form.closest('.mini-cart') ? 'drawer' : (form.closest('.card, .card-wrapper, .product-card') ? 'card' : 'pdp_form')),
        ci_product: String((meta.product && meta.product.id) || ''), ci_variant: String(vid || ''), ci_qty: qty
      });
      var variants = (meta.product && meta.product.variants) || [];
      var v = null;
      for (var i = 0; i < variants.length; i++) { if (variants[i].id === vid) v = variants[i]; }
      var titleEl = document.querySelector('.product__title h1, h1.product__title, .product__info-container h1, h1');
      var title = titleEl ? titleEl.textContent.trim() : (v && v.name ? v.name : '');
      /* og:image can be absent or point at a share image; prefer the actual
         gallery image the shopper is looking at (Ondrej 2026-08-31: first add
         painted a row with no thumbnail). */
      var galleryImg = document.querySelector('.product__media img:not(.ci-blur-up), .product__media-item img:not(.ci-blur-up), .product__info-container img');
      var ogImg = document.querySelector('meta[property="og:image"], meta[property="og:image:secure_url"]');
      var img = (galleryImg && (galleryImg.currentSrc || galleryImg.src)) || (ogImg ? ogImg.content : '');
      if (window.__ciWarmAdd) window.__ciWarmAdd(img, meta.product && meta.product.id);
      var variantTitle = v && v.public_title && v.public_title !== 'Default Title' ? v.public_title : '';
      /* price shown = what the PDP shows right now (sale-aware); struck
         compare from the PDP's own struck element when present */
      var pdpPrice = document.querySelector('.product__info-container .igPrice, .product__info-container .price-item--sale, .product__info-container .price__sale .price-item');
      var pdpCompare = document.querySelector('.product__info-container .igComparePrice, .product__info-container s.price-item--regular, .product__info-container .price s');
      var priceTxt = pdpPrice ? pdpPrice.textContent.trim() : '';
      if (!priceTxt && v && v.price) { priceTxt = '$' + (v.price / 100).toFixed(2).replace(/\.00$/, ''); }
      var compareTxt = pdpCompare ? pdpCompare.textContent.trim() : '';
      /* 2026-09-21 (Ondrej: cart shows LINE totals, not unit prices): the PDP
         always shows a per-unit price regardless of the qty selector, so
         scale priceTxt/compareTxt by qty in place (preserving the currency
         symbol's position) BEFORE the promo % calc below, so a discounted
         row paints as a correctly-scaled line total too and does not visibly
         re-price when the real render lands. Local to this IIFE on purpose —
         fmtNum/parseMoney live in the separate OPTIMISTIC QTY/REMOVE IIFE
         further down and are not reachable from here. */
      var ciScaleByQty = function (txt) {
        if (!txt || qty === 1) return txt;
        var mm = txt.match(/[0-9][0-9.,]*/);
        if (!mm) return txt;
        var val = (parseFloat(mm[0].replace(/,/g, '')) || 0) * qty;
        var hadDec = /\d[.]\d{2}/.test(mm[0]);
        var s = val.toFixed(2);
        if (!hadDec && /\.00$/.test(s)) s = s.slice(0, -3);
        var sParts = s.split('.');
        sParts[0] = sParts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        return txt.replace(mm[0], sParts.join('.'));
      };
      priceTxt = ciScaleByQty(priceTxt);
      compareTxt = ciScaleByQty(compareTxt);
      /* 2026-09-02: an automatic promo ("EXTRA 30% OFF at checkout") is applied
         by Shopify on the cart LINE, so the row must be painted at the
         discounted price or it visibly re-prices when the render lands
         (measured: 524.00 painted, 366.80 rendered). The promo snippet only
         renders for products inside the promo collection, so its presence is
         the eligibility test and its text carries the percentage. */
      var promoLine = '';
      try {
        var promoEl = document.querySelector('[data-sale-promo]');
        var promoMsg = promoEl && promoEl.querySelector('[data-sale-msg]');
        var promoTxt = promoEl ? ((promoMsg && promoMsg.getAttribute('data-msg-full')) || promoEl.textContent || '') : '';
        var pm = promoTxt.match(/(\d{1,2})\s*%\s*off/i);
        /* 2026-09-02 (Ondrej: paint everything as if it was already added):
           the promo line in the cart ("SALE: 30% OFF AT CHECKOUT") is Shopify's
           automatic discount title. We learn it from rendered cart lines
           (cached per session, see applyParityText) and use it when the PDP
           carries no promo snippet but the product is sale-eligible (Liquid
           flag from ci-sale-flag) or was already seen discounted. */
        var cached = null;
        try { cached = JSON.parse(sessionStorage.getItem('ci_promo') || 'null') || window.__ciPromoDefault || null; } catch (ce) { cached = window.__ciPromoDefault || null; }
        var handle = (meta.product && meta.product.handle) || (location.pathname.match(/\/products\/([^/?#]+)/) || [])[1] || '';
        var eligible = !!pm || window.__ciSaleEligible === true || (cached && cached.handles && cached.handles[handle]);
        if (!pm && cached && cached.pct && eligible) pm = [null, String(cached.pct)];
        var promoTitle = (cached && cached.title) || (pm ? 'SALE: ' + pm[1] + '% OFF AT CHECKOUT' : '');
        if (eligible && promoTitle) promoLine = '<ul class="discounts list-unstyled" role="list" aria-label="Discount"><li class="discounts__discount">' + String(promoTitle).replace(/</g, '&lt;') + '</li></ul>';
        var m0 = priceTxt.match(/[0-9][0-9.,]*/);
        /* Theme rule (mini-cart.liquid): a line shows compare + discounted final
           price only when the variant HAS a compare-at price; otherwise it shows
           the original price alone (the discount still applies at checkout). Paint
           the same. */
        if (pm && m0 && compareTxt) {
          var pct = parseInt(pm[1], 10);
          var base = parseFloat(m0[0].replace(/,/g, '')) || 0;
          if (pct > 0 && pct < 100 && base) {
            var parts = (base * (1 - pct / 100)).toFixed(2).split('.');
            parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
            priceTxt = priceTxt.replace(m0[0], parts.join('.'));
          }
        }
      } catch (e) {}
      if (typeof promoTitle === 'undefined') { var promoTitle = ''; }
      /* money waits for the server render (top of file) */
      if (window.__ciEstimateMoney !== true) { promoLine = ''; priceTxt = ''; compareTxt = ''; }
      var esc = function (t) { return String(t).replace(/</g, '&lt;'); };

      /* v3: if this variant already has a line, the server will MERGE —
         painting a second row caused a visible collapse (Ondrej's "flick").
         Bump the existing row in place instead: qty up, row to top (Shopify
         renders newest-first), totals adjusted by the per-unit price.
         2026-09-21: the drawer now renders item.final_line_price, a LINE
         TOTAL, so `existingPrice` holds the PRE-BUMP LINE TOTAL. Divide it
         back out by the pre-bump quantity to recover the unit, then scale
         both the row's own text and the totals delta from that unit. Reading
         it as a unit price double-counted quantity and left the row showing
         its old total until the server render landed. */
      var existingPrice = mc.querySelector('cart-items .igPrice[data-variant-id="' + vid + '"]');
      if (existingPrice) {
        var exRow = existingPrice.closest('li');
        var exInput = exRow && exRow.querySelector('.quantity__input');
        if (exRow && exInput) {
          /* Cart V4 grouping 2026-09-21: existingPrice's text is the
             GROUP's line total now (groupFinalTotal), not one Shopify
             line's. Re-derive the unit as groupFinalTotal / groupQty using
             li.dataset.quantity (the group total the row was RENDERED
             with), not exInput.value -- the quantity-input can diverge from
             the group total while a stepper change is still in flight (see
             the 'change' interception in the OPTIMISTIC QTY/REMOVE IIFE
             below). Fall back to the input for a row without the attribute
             (should not happen post-grouping, kept defensive). */
          var exOldQty = parseInt(exRow.dataset.quantity, 10);
          if (!exOldQty) exOldQty = parseInt(exInput.value, 10) || 0;
          var exNewQty = exOldQty + qty;
          exInput.value = exNewQty;
          exRow.dataset.quantity = String(exNewQty);
          exRow.classList.add('ci-opt-pulse');
          var exList = exRow.parentNode;
          if (exList && exList.firstChild !== exRow) exList.insertBefore(exRow, exList.firstChild);
          /* local copies: a helper defined in one IIFE is undefined in the
             next, which this file has been bitten by before. */
          var exFmt = function (v, template) {
            var hadDec = /\d[.]\d{2}/.test(template || '');
            if (v < 0) v = 0;
            var st = v.toFixed(2);
            if (!hadDec && /\.00$/.test(st)) st = st.slice(0, -3);
            var pp = st.split('.');
            pp[0] = pp[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
            return pp.join('.');
          };
          var exWrite = function (el, v) {
            if (!el) return;
            var h = el.innerHTML, mm = h.match(/[0-9][0-9.,]*/);
            if (mm) el.innerHTML = h.replace(mm[0], exFmt(v, mm[0]));
          };
          var exNum = function (t) { return parseFloat(String(t).replace(/[^0-9.]/g, '')) || 0; };
          var exLineSale = exNum(existingPrice.textContent || '');
          var compEl2 = exRow.querySelector('.ci-compare-price, .cart-item__discounted-prices .price--on-sale price-money bdi, s.igComparePrice price-money bdi');
          var exLineComp = compEl2 ? (exNum(compEl2.textContent) || exLineSale) : exLineSale;
          var unit = exOldQty ? (exLineSale / exOldQty) : exLineSale;
          var unitComp2 = exOldQty ? (exLineComp / exOldQty) : exLineComp;
          if (window.__ciEstimateMoney === true) {
            exWrite(existingPrice.querySelector('price-money bdi') || existingPrice, unit * exNewQty);
            if (compEl2) exWrite(compEl2, unitComp2 * exNewQty);
          } else {
            existingPrice.classList.add('ci-money-pending');
            if (compEl2) compEl2.classList.add('ci-money-pending');
          }
          if (window.__ciAdjustTotals) window.__ciAdjustTotals(unit * qty, unitComp2 * qty, qty);
          mc.classList.add('ci-optimistic-pending');
          revealRow(exRow);
          armWatchdog();
          return;
        }
      }

      var row = document.createElement('li');
      row.className = 'ci-optimistic-row ci-opt-pulse';
      row.innerHTML =
        '<div class="product-container">' +
          (img ? '<div><span class="product-image media-wrapper media-wrapper--small"><img src="' + img + '" alt="" width="70" style="width:100%;display:block;"></span></div>' : '') +
          '<div class="product-description">' +
            '<div class="product-content"><span class="link product-title">' + esc(title) + '</span></div>' +
            (variantTitle ? '<dl><div class="product-option"><dd>' + esc(variantTitle) + '</dd></div></dl>' : '') +
            promoLine +
            '<div class="product-quantity">' +
              '<dt><quantity-input class="quantity">' +
                '<button class="quantity__button" type="button" disabled aria-hidden="true">&minus;</button>' +
                '<input class="quantity__input" type="text" value="' + qty + '" readonly aria-label="Quantity">' +
                '<button class="quantity__button" type="button" disabled aria-hidden="true">&#43;</button>' +
              '</quantity-input></dt>' +
              ((compareTxt && esc(compareTxt)) ? '<dl class="cart-item__discounted-prices"><dt class="visually-hidden">Regular price</dt><dd class="price--on-sale"><s class="price price-item--regular igComparePrice" data-variant-id="' + vid + '"><price-money><bdi>' + (compareTxt && esc(compareTxt)) + '</bdi></price-money></s></dd><dt class="visually-hidden">Sale price</dt><dd class="price igPrice" data-variant-id="' + vid + '"><price-money><bdi>' + (esc(priceTxt)) + '</bdi></price-money></dd></dl>' : '<dd class="price igPrice" data-variant-id="' + vid + '"><price-money><bdi>' + (esc(priceTxt)) + '</bdi></price-money></dd>') +
            '</div>' +
          '</div>' +
          '<cart-remove-button><span class="delete-product" aria-hidden="true"></span></cart-remove-button>' +
        '</div>';

      mc.classList.remove('is-empty');
      mc.classList.add('ci-optimistic-pending');
      var listEl = null;
      var ci = mc.querySelector('cart-items');
      if (ci) listEl = ci.querySelector('.mini-cart__navigation');
      /* Totals for a NEW line (the merge path already did this): without it
         the first add showed "Subtotal $0" and a stale free-shipping line. */
      try {
        var newUnit = parseFloat(String(priceTxt).replace(/[^0-9.]/g, '')) || 0;
        var newComp = parseFloat(String(compareTxt).replace(/[^0-9.]/g, '')) || newUnit;
        if (newUnit && window.__ciAdjustTotals) {
          window.__ciAdjustTotals(newUnit * qty, newComp * qty, qty);
        }
      } catch (e) {}

      window.__ciPendingRowHTML = row.outerHTML;
      if (listEl) {
        listEl.insertBefore(row, listEl.firstChild);
        revealRow(row);
      } else {
        var ul = document.createElement('ul');
        ul.className = 'mini-cart__navigation ci-optimistic-list';
        ul.appendChild(row);
        var hdr = mc.querySelector('.mini-cart__header');
        if (hdr && hdr.parentNode) hdr.insertAdjacentElement('afterend', ul);
        else mc.insertBefore(ul, mc.firstChild);
      }
      armWatchdog();
    } catch (e) { /* optimistic layer must never interfere with the real add */ }
  }
  /* Fired from BOTH paths: a real form submit, and a click on any add button
     (the sticky PDP bar's button lives OUTSIDE the product form and submits
     it programmatically, so no submit event reaches this listener in time —
     Ondrej 2026-08-31). The in-flight guard inside makes the double call
     harmless. */
  document.addEventListener('submit', function (ev) { ciOptimisticAdd(ev.target); }, true);
  document.addEventListener('click', function (ev) {
    try {
      var btn = ev.target.closest && ev.target.closest('button[name="add"], .product-form__submit');
      if (!btn || btn.disabled || btn.hasAttribute('data-sticky-notify')) return;
      var form = btn.closest('form[action*="/cart/add"]') ||
                 document.querySelector('form[action*="/cart/add"]:not([id*="installment"])');
      if (form) ciOptimisticAdd(form);
    } catch (e) {}
  }, true);
})();

/* ---------- OPTIMISTIC QTY / REMOVE (2026-08-28, Ondrej) ----------
   Same philosophy as optimistic ATC: never touch the theme's real
   /cart/change flow; on a stepper click or trash click, instantly repaint
   the derived numbers (line price, subtotal, CTA total, item count,
   free-shipping remaining) or hide the row. The real section render
   reconciles ~1s later and is always authoritative. All string-money math
   is display-only and tolerant of both "$1,159.20" and "1,159.20 ฿". */
(function () {
  function parseMoney(str) {
    var n = String(str || '').replace(/[^0-9.]/g, '');
    return parseFloat(n) || 0;
  }
  function fmtNum(v, template) {
    var hadDec = /\d[.]\d{2}/.test(template || '');
    if (v < 0) v = 0;
    var s = v.toFixed(2);
    if (!hadDec && /\.00$/.test(s)) s = s.slice(0, -3);
    var parts = s.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return parts.join('.');
  }
  function replaceAmount(el, newVal) {
    if (!el) return;
    var html = el.innerHTML;
    var m = html.match(/[0-9][0-9.,]*/);
    if (!m) return;
    el.innerHTML = html.replace(m[0], fmtNum(newVal, m[0]));
  }
  function adjustTotals(deltaSale, deltaCompare, deltaCount) {
    var mc = document.querySelector('.mini-cart');
    if (!mc) return;
    /* money waits for the server render (top of file): dim the subtotal,
       its struck compare, the savings chip and the band's amount, and leave
       their values alone. The render replaces these nodes, which clears it. */
    if (window.__ciEstimateMoney !== true) {
      mc.querySelectorAll('.subtotal .value, .subtotal [class*="save"], .button-container button[name="checkout"] .price, .free-shipping__text').forEach(function (el) {
        el.classList.add('ci-money-pending');
      });
      return;
    }
    /* subtotal (sale + struck compare) */
    var sub = mc.querySelector('.subtotal .value');
    if (sub) {
      var comp = sub.querySelector('.ci-subtotal-compare');
      var compVal = comp ? parseMoney(comp.textContent) + deltaCompare : 0;
      var saleTxt = sub.childNodes[0] && sub.childNodes[0].nodeType === 3 ? sub.childNodes[0].nodeValue : sub.textContent;
      var saleVal = parseMoney(comp ? saleTxt : sub.textContent) + deltaSale;
      if (sub.childNodes[0] && sub.childNodes[0].nodeType === 3) {
        var t = sub.childNodes[0].nodeValue;
        var m = t.match(/[0-9][0-9.,]*/);
        if (m) sub.childNodes[0].nodeValue = t.replace(m[0], fmtNum(saleVal, m[0]));
      } else {
        replaceAmount(sub, saleVal);
      }
      if (comp) replaceAmount(comp, compVal);
    }
    /* CTA total */
    replaceAmount(mc.querySelector('.button-container button[name="checkout"] .price'), 
      parseMoney((mc.querySelector('.button-container button[name="checkout"] .price') || {}).textContent) + deltaSale);
    /* item count */
    var label = mc.querySelector('.subtotal .label');
    if (label && deltaCount) {
      var lm = label.textContent.match(/\((\d+)/);
      if (lm) {
        var n = Math.max(0, parseInt(lm[1], 10) + deltaCount);
        label.textContent = document.querySelector('.mini-cart.ci-cart-v4') ? 'Subtotal' : 'Subtotal (' + n + (n === 1 ? ' item' : ' items') + ')';
      }
    }
    /* free shipping remaining */
    var fs = mc.querySelector('.free-shipping__text:not(.free-shipping__text--success)');
    if (fs) {
      var amt = fs.querySelector('.price bdi') || fs.querySelector('.price') || fs.querySelector('b');
      if (amt && /[0-9]/.test(amt.textContent)) {
        replaceAmount(amt, parseMoney(amt.textContent) - deltaSale);
      }
    }
  }
  function lineNumbers(li) {
    /* 2026-09-21: sale/comp are now LINE TOTALS, not unit prices — this
       theme renders item.final_line_price / the qty-scaled compare-at
       (mini-cart.liquid, Ondrej: "in cart ... item prices ... total, not
       per unit"), so a line's price display DOES change with quantity.
       Divide by .qty to recover the per-unit price when you need one. */
    /* Cart V4 grouping 2026-09-21: a row can now be several merged Shopify
       lines rendered as one <li>. li.dataset.quantity is the GROUP total
       (Liquid renders it as ci_g_qty and the stepper interception below
       keeps it current across changes); the quantity-input's own value can
       briefly hold the PRIMARY line's post-change quantity instead (see the
       'change' interception further down), so prefer the dataset when a row
       carries it and only fall back to the input for rows that don't
       (synthetic optimistic rows have no data-quantity attribute). */
    var qtyInput = li.querySelector('.quantity__input');
    var qty;
    if (li.dataset.quantity !== undefined) {
      qty = parseInt(li.dataset.quantity, 10) || 0;
    } else {
      qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
    }
    var saleEl = li.querySelector('.cart-item__discounted-prices dd.price:not(.price--on-sale) price-money bdi, dd.price price-money bdi');
    var compEl = li.querySelector('.cart-item__discounted-prices .price--on-sale price-money bdi, .ci-compare-price');
    var sale = saleEl ? parseMoney(saleEl.textContent) : 0;
    var comp = compEl ? parseMoney(compEl.textContent) : sale;
    return { qty: qty, sale: sale, comp: comp, saleEl: saleEl, compEl: compEl };
  }
  window.__ciAdjustTotals = adjustTotals;

  /* ---- 2026-09-21 grouped-row stepper math (Ondrej: BOGO free units get
     their own row) ----
     mini-cart.liquid now renders ONE <li> per (variant_id, unit final price)
     GROUP, so the quantity-input DISPLAYS the group total (li.dataset.quantity)
     while its own data-index/value still target the PRIMARY member (the
     group's largest-quantity line), whose own quantity is smaller. Posting
     the displayed value directly would over-set that one line. Intercept the
     change in capture phase -- before the theme's own change handler
     (bound on an ancestor, not capture) reads input.value -- and rewrite it
     to the primary line's new quantity. data-index is already correct
     (Liquid renders it from the primary member), so the theme's existing
     /cart/change flow posts the right thing without anything else changing.
     Shopify re-splits the lines after every change, so only the resulting
     TOTAL has to be right.
     li.dataset.quantity / data-primary-qty are kept in sync with what we
     just posted (not explicitly specified by the spec, but required so a
     SECOND change before the next render still computes its delta against
     the latest state instead of the stale server-rendered numbers). */
  document.addEventListener('change', function (ev) {
    try {
      if (!document.documentElement.classList.contains('ci-native-cart')) return;
      var input = ev.target;
      if (!input || !input.matches || !input.matches('.mini-cart cart-items .quantity__input')) return;
      var li = input.closest('li');
      if (!li || li.dataset.primaryQty === undefined) return;
      var oldGroupQty = Number(li.dataset.quantity) || 0;
      var oldPrimaryQty = Number(li.dataset.primaryQty) || 0;
      var newDisplayedValue = Number(input.value) || 0;
      var delta = newDisplayedValue - oldGroupQty;
      var primaryNewQty = oldPrimaryQty + delta;
      if (primaryNewQty < 0) primaryNewQty = 0;
      var appliedDelta = primaryNewQty - oldPrimaryQty;
      /* 2026-09-23, Ondrej: "when I'm decreasing quantity using the stepper,
         it flickers at 1 every time". This used to write primaryNewQty into
         the VISIBLE input, which the shopper saw for the theme's 300ms
         debounce + the /cart/change round trip (a BOGO-split row's primary
         line is often qty 1). The box now keeps the group total; the
         translation to the primary line happens at post time in the
         CartItems.onChange wrap below. Only a clamp touches the box. */
      if (appliedDelta !== delta) input.value = String(oldGroupQty + appliedDelta);
      li.dataset.quantity = String(oldGroupQty + appliedDelta);
      li.dataset.primaryQty = String(primaryNewQty);
    } catch (e) { /* never block the native change flow */ }
  }, true);
  /* Post the primary line's quantity (accumulated in data-primary-qty by the
     capture handler above, once per click, so a debounced burst of clicks
     posts the right total). Wraps onChange, not updateQuantity, because
     cart-remove-button also calls updateQuantity(index, 0). */
  if (window.customElements) customElements.whenDefined('cart-items').then(function () {
    try {
      var CI = customElements.get('cart-items');
      if (!CI || CI.prototype.__ciGroupWrapped) return;
      var origOnChange = CI.prototype.onChange;
      CI.prototype.onChange = function (event) {
        try {
          var t = event && event.target;
          var li = t && t.matches && t.matches('.mini-cart cart-items .quantity__input') && t.closest('li');
          if (li && li.dataset.primaryQty !== undefined && document.documentElement.classList.contains('ci-native-cart')) {
            return this.updateQuantity(t.dataset.index, li.dataset.primaryQty, document.activeElement && document.activeElement.getAttribute('name'));
          }
        } catch (e) {}
        return origOnChange.apply(this, arguments);
      };
      CI.prototype.__ciGroupWrapped = true;
    } catch (e) {}
  });

  /* 2026-09-02 reliability pass: a remove / qty change whose /cart/change
     request fails used to leave the row dimmed-and-spinning forever with
     the totals already adjusted. The theme's own catch path re-hides its
     .loading-overlay WITHOUT rendering, which is our failure signal; a 9s
     watchdog backstops a request that never returns at all. Both hand off
     to the shared reconcile (clear optimistic state, re-pull the drawer,
     one-line note). */
  var rmTimer = null;
  function armRemoveWatchdog() {
    clearTimeout(rmTimer);
    rmTimer = setTimeout(function () {
      if (document.querySelector('.mini-cart .ci-opt-removing, .mini-cart .ci-opt-qtying') && window.__ciReconcile) {
        window.__ciReconcile("Your cart didn't update. Please try again.");
      }
    }, 9000);
  }
  document.addEventListener('ci:cart:rerendered', function () { clearTimeout(rmTimer); });
  (function watchOverlay() {
    var host = document.getElementById('mini-cart');
    if (!host || typeof MutationObserver === 'undefined') return;
    /* read-only on the observed subtree except through reconcile, which only
       runs on a failure and immediately clears the state it keys on */
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var t = muts[i].target;
        if (!t || !t.classList || !t.classList.contains('loading-overlay') || !t.classList.contains('hidden')) continue;
        var row = t.closest && t.closest('.ci-opt-removing, .ci-opt-qtying');
        if (row && window.__ciReconcile) {
          setTimeout(function () {
            if (Date.now() - (window.__ciLastRenderAt || 0) < 700) return;   /* render landed */
            if (!document.querySelector('.mini-cart .ci-opt-removing, .mini-cart .ci-opt-qtying')) return;
            window.__ciReconcile("Your cart didn't update. Please try again.");
          }, 250);
          return;
        }
      }
    }).observe(host, { subtree: true, attributes: true, attributeFilter: ['class'] });
  })();

  document.addEventListener('click', function (ev) {
    try {
      if (!document.documentElement.classList.contains('ci-native-cart')) return;
      var mc = document.querySelector('.mini-cart');
      if (!mc) return;

      /* ---- remove ---- */
      var rm = ev.target.closest && ev.target.closest('.mini-cart cart-remove-button');
      if (rm) {
        var li = rm.closest('li');
        /* 2026-09-22, Ondrej: "grey out X on free product". The CSS greys it
           off li[data-free="true"] and drops pointer-events, but a keyboard
           activation still reaches this handler, so refuse here too. The row
           keeps the control's shape, not its action; minus stays live. Why it
           cannot act: BOGO is cart-wide, so removing a free line is not a
           local edit (6 units -> the row returns at qty 1; mixed cart -> the
           free-ness hops to a sibling unit). See the comment block above
           cart-remove-button in sections/mini-cart.liquid for the measurements. */
        if (li && li.getAttribute('data-free') === 'true') {
          ev.preventDefault();
          ev.stopImmediatePropagation();
          return;
        }
        if (li && !li.classList.contains('ci-opt-removed')) {
          var n = lineNumbers(li);
          li.classList.add('ci-opt-removed');
          /* Ondrej 2026-08-31: instant-hide plus a frozen second read as a
             glitch. Keep the row visible but dimmed and pulsing with a
             spinner over the trash until the real render drops it. */
          li.classList.add('ci-opt-removing');
          armRemoveWatchdog();
          /* 2026-09-21 FIX. This block still multiplied by n.qty under the
             comment "unit price x qty", but lineNumbers() has returned LINE
             TOTALS since the line-total change earlier today (see its own
             header comment): n.sale is already the whole row. Multiplying
             again subtracted qty times too much, so removing the 3-pyramid
             row optimistically took 70.35 x 3 = 211.05 off an 89.80
             subtotal until the server render landed and corrected it.
             The tracking value was wrong the same way, and that one does
             NOT get corrected by a re-render: ci_cart_remove was reporting
             a line value of 211.05 for a 70.35 row. Subtract the totals as
             they are. */
          try { window.__ciTrack && window.__ciTrack('ci_cart_remove', { ci_qty: n.qty, ci_line: Math.round(n.sale * 100) / 100, ci_items: mc.querySelectorAll('cart-items li').length }); } catch (te) {}
          adjustTotals(-n.sale, -n.comp, -n.qty);

          /* Cart V4 grouping 2026-09-21: a merged row maps to SEVERAL
             Shopify line keys (li.dataset.lineKeys). The stock remove
             control (this element's own href / click handling) only ever
             targets ONE line, which would leave the row's other members in
             the cart. Take the removal over ourselves: block the native
             path (it would fire on the same click, on the anchor's href or
             the custom element's own listener) and zero every key in one
             request. */
          ev.preventDefault();
          ev.stopImmediatePropagation();
          /* 2026-09-22 X-BUTTON FIX (Ondrej: "sometimes I tap it and it
             doesn't remove all the pieces, happens when there is like three
             plus pieces of an item"). data-line-keys is this GROUP's keys
             (variant_id + final_price). Under BOGO one variant sits in TWO
             groups, so that attribute left the free line in the cart and
             Shopify re-priced it: measured, 3 units, tap X on the paid row,
             ONE UNIT LEFT AT FULL PRICE. data-all-keys carries every key of
             the variant. The single atomic update below is required, not a
             style choice: sequential per-key calls fail because each write
             re-keys the surviving lines, and updates keyed by variant id zero
             only one of the split lines. Verified at 3/6/7/9 units and mixed. */
          var lineKeysAttr = li.getAttribute('data-all-keys') || li.getAttribute('data-line-keys');
          var rmKeys = lineKeysAttr ? lineKeysAttr.split(',').filter(Boolean) : [];
          if (rmKeys.length) {
            fetch('/cart/update.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ updates: Object.fromEntries(rmKeys.map(function (k) { return [k, 0]; })) })
            })
              .then(function () { if (window.__ciDrawerRefresh) window.__ciDrawerRefresh(); })
              .catch(function () { if (window.__ciReconcile) window.__ciReconcile("Your cart didn't update. Please try again."); });
          }
        }
        return;
      }

      /* ---- drawer recommendation ADD: paint the new line instantly ---- */
      var recAdd = ev.target.closest && ev.target.closest('.mini-cart cart-recommendations add-to-cart');
      if (recAdd) {
        var recVid = recAdd.getAttribute('data-variant-id');
        try {
          var recLi = recAdd.closest('li');
          var T = window.__ciTrack;
          if (T && recLi) {
            var rf = { ci_surface: 'drawer', ci_host: recLi.getAttribute('data-rec-host') || '', ci_candidate: recLi.getAttribute('data-rec-candidate') || '',
              ci_rank: recLi.getAttribute('data-rec-rank') || '', ci_pos: recLi.getAttribute('data-rec-pos') || '', ci_intent: recLi.getAttribute('data-rec-intent') || '',
              ci_variant: String(recVid || ''), ci_chooser: recLi.querySelector('.ci-rec-variant') ? 1 : 0 };
            T('ci_rec_add', rf);
            T('ci_cart_add', { ci_source: 'drawer_rec', ci_product: rf.ci_candidate, ci_variant: rf.ci_variant, ci_qty: 1 });
          }
        } catch (te) {}
        var recExisting = recVid ? mc.querySelector('cart-items .igPrice[data-variant-id="' + recVid + '"]') : null;
        if (recExisting) {
          var rRow = recExisting.closest('li');
          var rInput = rRow && rRow.querySelector('.quantity__input');
          if (rRow && rInput) {
            /* Cart V4 grouping 2026-09-21: same re-derivation as the PDP
               merge branch above -- prefer li.dataset.quantity (the group
               total) over rInput.value, which can diverge from it while a
               stepper change is in flight. */
            var rOldQty = parseInt(rRow.dataset.quantity, 10);
            if (!rOldQty) rOldQty = parseInt(rInput.value, 10) || 0;
            var rNewQty = rOldQty + 1;
            rInput.value = rNewQty;
            rRow.dataset.quantity = String(rNewQty);
            rRow.classList.add('ci-opt-pulse');
            if (rRow.parentNode && rRow.parentNode.firstChild !== rRow) rRow.parentNode.insertBefore(rRow, rRow.parentNode.firstChild);
            /* 2026-09-21: same line-total correction as the PDP merge branch
               above. These elements hold the PRE-BUMP LINE TOTAL now, so
               divide by the old quantity before scaling, and rewrite the
               row's own text or it keeps the stale total on screen. */
            var rLineSale = parseMoney(recExisting.textContent);
            var rCompEl = rRow.querySelector('.ci-compare-price, .cart-item__discounted-prices .price--on-sale price-money bdi, s.igComparePrice price-money bdi');
            var rLineComp = rCompEl ? parseMoney(rCompEl.textContent) : rLineSale;
            var rUnit = rOldQty ? (rLineSale / rOldQty) : rLineSale;
            var rUnitComp = rOldQty ? (rLineComp / rOldQty) : rLineComp;
            if (window.__ciEstimateMoney === true) {
              replaceAmount(recExisting.querySelector('price-money bdi') || recExisting, rUnit * rNewQty);
              if (rCompEl) replaceAmount(rCompEl, rUnitComp * rNewQty);
            } else {
              recExisting.classList.add('ci-money-pending');
              if (rCompEl) rCompEl.classList.add('ci-money-pending');
            }
            adjustTotals(rUnit, rUnitComp, 1);
          }
          return;
        }
        var rec = recAdd.closest('.ci-rec');
        var listEl = mc.querySelector('cart-items .mini-cart__navigation');
        if (rec && listEl) {
          var rTitle = (rec.querySelector('.product-title') || {}).textContent || '';
          var rImg = (rec.querySelector('.product-image img') || {}).currentSrc || '';
          var rSaleEl = rec.querySelector('.ci-rec-price__sale');
          var rCompEl = rec.querySelector('.ci-rec-price__was');
          var rSale = rSaleEl ? parseMoney(rSaleEl.textContent) : 0;
          var rComp = rCompEl ? parseMoney(rCompEl.textContent) : rSale;
          /* 2026-09-02: paint the SALE line too (Ondrej: everything as if already
             added). Eligibility comes from the row (data-rec-sale, same collection
             rule as the PDP flag); the title is the automatic discount's, learned
             from rendered lines earlier in the session. */
          var rPromo = '', rPct = 0;
          try {
            var rLi = rec.closest('li');
            var rc = window.__ciEstimateMoney === true ? (JSON.parse(sessionStorage.getItem('ci_promo') || 'null') || window.__ciPromoDefault || null) : null;
            if (rLi && rLi.getAttribute('data-rec-sale') === '1' && rc && rc.title) { rPromo = rc.title; rPct = parseInt(rc.pct, 10) || 0; }
          } catch (pe) {}
          var rSaleTxt = rSaleEl ? rSaleEl.textContent.trim() : '';
          var rCompTxt = rCompEl ? rCompEl.textContent.trim() : '';
          if (rPct > 0 && rPct < 100 && rCompEl && rSale) {
            /* same rule as the PDP path: discounted final price only next to a compare-at */
            var rm0 = rSaleTxt.match(/[0-9][0-9.,]*/);
            if (rm0) {
              var rParts = (rSale * (1 - rPct / 100)).toFixed(2).split('.');
              rParts[0] = rParts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
              rSaleTxt = rSaleTxt.replace(rm0[0], rParts.join('.'));
              rSale = rSale * (1 - rPct / 100);
            }
          }
          /* money waits for the server render (top of file) */
          if (window.__ciEstimateMoney !== true) { rPromo = ''; rSaleTxt = ''; rCompTxt = ''; }
          var rOptSel = rec.querySelector('.ci-rec-variant');
          var rOptTxt = rOptSel && rOptSel.options[rOptSel.selectedIndex] ? rOptSel.options[rOptSel.selectedIndex].textContent.trim() : '';
          var li2 = document.createElement('li');
          li2.className = 'ci-optimistic-row ci-opt-pulse';
          /* 2026-08-31: this row still used the v1 "Qty 1 <price>" markup, so
             a drawer-upsell add looked nothing like a main-ATC add (Ondrej's
             screenshot: price on the left, no stepper). Same clone structure
             as every other optimistic row now. */
          li2.innerHTML =
            '<div class="product-container">' +
              (rImg ? '<div><span class="product-image media-wrapper media-wrapper--small"><img src="' + rImg + '" alt="" style="width:100%;display:block;"></span></div>' : '') +
              '<div class="product-description">' +
                '<div class="product-content"><span class="link product-title">' + rTitle.replace(/</g, '&lt;').trim() + '</span></div>' +
                (rOptTxt ? '<dl><div class="product-option"><dd>' + rOptTxt.replace(/</g, '&lt;') + '</dd></div></dl>' : '') +
                (rPromo ? '<ul class="discounts list-unstyled" role="list" aria-label="Discount"><li class="discounts__discount">' + rPromo.replace(/</g, '&lt;') + '</li></ul>' : '') +
                '<div class="product-quantity">' +
                  '<dt><quantity-input class="quantity">' +
                    '<button class="quantity__button" type="button" disabled aria-hidden="true">&minus;</button>' +
                    '<input class="quantity__input" type="text" value="1" readonly aria-label="Quantity">' +
                    '<button class="quantity__button" type="button" disabled aria-hidden="true">&#43;</button>' +
                  '</quantity-input></dt>' +
                  ((rCompTxt) ? '<dl class="cart-item__discounted-prices"><dt class="visually-hidden">Regular price</dt><dd class="price--on-sale"><s class="price price-item--regular igComparePrice" data-variant-id="' + recVid + '"><price-money><bdi>' + (rCompTxt) + '</bdi></price-money></s></dd><dt class="visually-hidden">Sale price</dt><dd class="price igPrice" data-variant-id="' + recVid + '"><price-money><bdi>' + (rSaleTxt) + '</bdi></price-money></dd></dl>' : '<dd class="price igPrice" data-variant-id="' + recVid + '"><price-money><bdi>' + (rSaleTxt) + '</bdi></price-money></dd>') +
                '</div>' +
              '</div>' +
              '<cart-remove-button><span class="delete-product" aria-hidden="true"></span></cart-remove-button>' +
            '</div>';
          listEl.insertBefore(li2, listEl.firstChild);
          adjustTotals(rSale, rComp, 1);
          setTimeout(function () { if (li2.parentNode) li2.remove(); }, 12000);
        }
        return;
      }

      /* ---- checkout ---- */
      var co = ev.target.closest && ev.target.closest('.mini-cart button[name="checkout"], .mini-cart a[href*="/checkout"]');
      if (co) {
        try {
          var coPrice = mc.querySelector('.button-container button[name="checkout"] .price');
          window.__ciTrack && window.__ciTrack('ci_cart_checkout', { ci_items: mc.querySelectorAll('cart-items li').length,
            ci_subtotal: coPrice ? parseMoney(coPrice.textContent) : 0,
            ci_secs_open: window.__ciCartOpenedAt ? Math.round((Date.now() - window.__ciCartOpenedAt) / 1000) : 0 });
        } catch (te) {}
        return;
      }

      /* ---- qty stepper ---- */
      var btn = ev.target.closest && ev.target.closest('.mini-cart cart-items .quantity__button');
      if (btn) {
        var row = btn.closest('li');
        if (!row) return;
        var before = lineNumbers(row);
        /* same feedback language as removal (Ondrej 2026-08-31): pulse the
           row + spin a ring by the stepper until the render confirms. Kept
           clickable so rapid +/- still works. */
        row.classList.add('ci-opt-qtying');
        armRemoveWatchdog();
        setTimeout(function () {
          try {
            var after = lineNumbers(row);
            var delta = after.qty - before.qty;
            if (!delta) return;
            /* 2026-09-21: before.sale/before.comp are LINE TOTALS for the
               PRE-click qty (see the doc comment on lineNumbers). Recover the
               stored UNIT price by dividing the qty back out, then rewrite
               the row's own price text as unit x new qty -- the price
               display is no longer flat across a qty change. */
            var unitSale = before.sale / (before.qty || 1);
            var unitComp = before.comp / (before.qty || 1);
            try { window.__ciTrack && window.__ciTrack('ci_cart_qty', { ci_from: before.qty, ci_to: after.qty, ci_unit: unitSale }); } catch (te) {}
            if (window.__ciEstimateMoney === true) {
              if (before.saleEl) replaceAmount(before.saleEl, unitSale * after.qty);
              if (before.compEl) replaceAmount(before.compEl, unitComp * after.qty);
            } else {
              if (before.saleEl) before.saleEl.classList.add('ci-money-pending');
              if (before.compEl) before.compEl.classList.add('ci-money-pending');
            }
            /* totals still move by the per-unit price x the qty delta */
            adjustTotals(unitSale * delta, unitComp * delta, delta);
          } catch (e) {}
        }, 0);
      }
    } catch (e) { /* display-only layer; the real render reconciles */ }
  }, true);
})();

/* ---- 2026-09-23 picks strip: desktop scroll arrows ----
   Ondrej: "add a gentle orchid arrow to the right in the upsell widget on
   desktop, so it's obvious one can scroll through it or click through it,
   because on desktop you cannot swipe. On mobile don't add the same."
   One cream disc with an orchid chevron at the strip's right edge, shown only
   while there is more to the right; a matching left disc appears once the
   strip has moved, or a mouse user could not get back. Visibility is CSS-gated
   to (hover: hover) and (pointer: fine), so touch devices never see them.
   Covers both strips: the filled cart's <cart-recommendations> and the empty
   cart's best sellers. The drawer re-renders its whole section on every cart
   change, so the discs are (re)attached from a childList-only observer on
   #mini-cart; ensure() only ever INSERTS when a disc is missing, so its own
   insert finds them present on the next pass and cannot loop, and the state
   updates are attribute writes, which the observer does not watch. */
(function () {
  var CHEV = '<svg width="17" height="17" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M9 5l7 7-7 7" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  function strips() {
    return document.querySelectorAll('.mini-cart.ci-cart-v4 cart-recommendations, .mini-cart.ci-cart-v4 .cart-recommendations');
  }
  function update(box) {
    var ul = box.querySelector('.mini-cart__navigation');
    if (!ul) return;
    var more = ul.scrollLeft + ul.clientWidth < ul.scrollWidth - 2;
    var prev = ul.scrollLeft > 2;
    box.classList.toggle('ci-has-more', more);
    box.classList.toggle('ci-has-prev', prev);
    /* centre the discs on the 136px photos, whatever sits above the strip */
    box.querySelectorAll('.ci-strip-arrow').forEach(function (b) {
      var v = (ul.offsetTop + 68 - Math.round((b.offsetHeight || 38) / 2)) + 'px';
      if (b.style.top !== v) b.style.top = v;
    });
  }
  function ensure() {
    Array.prototype.forEach.call(strips(), function (box) {
      if (!box.querySelector('.mini-cart__navigation')) return;
      if (!box.querySelector(':scope > .ci-strip-arrow--right')) {
        ['left', 'right'].forEach(function (dir) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'ci-strip-arrow ci-strip-arrow--' + dir;
          b.setAttribute('aria-label', dir === 'right' ? 'More picks' : 'Previous picks');
          b.tabIndex = -1;
          b.innerHTML = CHEV;
          box.appendChild(b);
        });
      }
      update(box);
    });
  }
  document.addEventListener('click', function (ev) {
    var b = ev.target.closest && ev.target.closest('.ci-strip-arrow');
    if (!b) return;
    ev.preventDefault();
    var box = b.parentElement;
    var ul = box && box.querySelector('.mini-cart__navigation');
    if (!ul) return;
    var dir = b.classList.contains('ci-strip-arrow--left') ? -1 : 1;
    /* one card is 136px + a 10px gap; move by the whole cards that fit
       minus one, so the last visible card stays as the anchor */
    var step = Math.max(146, (Math.floor(ul.clientWidth / 146) - 1) * 146);
    ul.scrollBy({ left: dir * step, behavior: 'smooth' });
    try { window.__ciTrack && window.__ciTrack('ci_rec_arrow', { ci_dir: dir > 0 ? 'right' : 'left', ci_strip: box.classList.contains('ci-empty-bestsellers') ? 'empty' : 'recommended' }); } catch (te) {}
  });
  /* scroll does not bubble; capture it for any strip */
  document.addEventListener('scroll', function (ev) {
    var ul = ev.target;
    if (!ul || !ul.classList || !ul.classList.contains('mini-cart__navigation')) return;
    var box = ul.closest('cart-recommendations, .cart-recommendations');
    if (box) update(box);
  }, true);
  window.addEventListener('resize', function () { Array.prototype.forEach.call(strips(), update); });
  var pending = null;
  function schedule() { clearTimeout(pending); pending = setTimeout(ensure, 60); }
  function start() {
    var host = document.getElementById('mini-cart');
    ensure();
    if (!host || typeof MutationObserver === 'undefined') return;
    new MutationObserver(schedule).observe(host, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();


/* ---- 2026-10-09 drawer picks More info sheet (Ondrej: keep shoppers in the cart, no redirect to the product page) ----
   The picks strip tiles used to link out to the product page from the photo and
   the title, which took shoppers out of the cart. Photo and title (the two
   anchors marked data-ci-pick-info) now open a bottom sheet INSIDE
   the drawer, filled from the tile's inert <template data-ci-pick-info-content>
   (snippets/ci-drawer-rec-row.liquid), with a sticky ADD. The anchors keep their
   href as the no-JS fallback; the capture-phase click below cancels navigation.
   Rules this file lives by:
   - The drawer re-renders by innerHTML, so the sheet is appended to #mini-cart
     (which persists) and simply disappears if a re-render lands while it is
     open. Nothing is bound per sheet except on the sheet's own nodes, so
     nothing leaks; the three document/window listeners below are permanent and
     check whether the sheet is still connected.
   - Closed = node removed. No opacity:0 leftovers (a closed, composited layer
     is what crashed iOS Safari on pinch, see the shopify-theme-dev skill).
   - ADD reuses the tile's own add-to-cart element so the optimistic paint and
     the ci_rec_add tracking all run unchanged. global.js reads
     this.dataset.properties synchronously at click time, so swapping
     "_upsell_path" from tile to info for the duration of .click() and restoring
     it afterwards posts the info path on the line item.
   - ci-discovery.js records a click-through for any <a> in a recommendation
     surface; it gets a one-line guard for [data-ci-pick-info] anchors, since
     opening the sheet is not a click-through. */
(function () {
  var sheet = null;      /* the open sheet node, or null */
  var ctx = null;        /* { li, trigger, pid, rank, strip, variantId, props, title, price } */
  var closing = false;
  var closeTimer = 0;
  var escSwallow = false;
  var X_SVG = '<svg viewBox="0 0 14 14" width="14" height="14" fill="none" aria-hidden="true"><path d="M1.5 1.5l11 11M12.5 1.5l-11 11" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>';
  var CHEV_SVG = '<svg viewBox="0 0 9 14" width="9" height="14" fill="none" aria-hidden="true"><path d="M1.5 1.5L7 7l-5.5 5.5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var CHECK_SVG = '<svg viewBox="0 0 16 16" width="16" height="16" fill="none" aria-hidden="true"><path d="M3 8.5l3.2 3.2L13 4.8" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function host() { return document.getElementById('mini-cart'); }
  function track(name, params) { try { if (window.__ciTrack) window.__ciTrack(name, params); } catch (e) {} }
  function alive() { return !!(sheet && sheet.isConnected); }

  function trackParams(extra) {
    var p = { ci_candidate: ctx.pid, ci_rank: ctx.rank, ci_strip: ctx.strip };
    if (extra) for (var k in extra) p[k] = extra[k];
    return p;
  }

  /* Drop the node now (no animation) and forget its state. */
  function removeNow() {
    clearTimeout(closeTimer);
    if (sheet && sheet.parentNode) sheet.parentNode.removeChild(sheet);
    sheet = null; ctx = null; closing = false;
  }

  function closeSheet() {
    if (!sheet || closing) return;
    if (!sheet.isConnected) { removeNow(); return; }
    closing = true;
    var trigger = ctx && ctx.trigger;
    sheet.classList.remove('is-open');
    sheet.classList.add('is-closing');
    closeTimer = setTimeout(function () {
      removeNow();
      try { if (trigger && trigger.isConnected && trigger.focus) trigger.focus({ preventScroll: true }); } catch (e) {}
    }, 320);
  }

  function updateNav(strip, prev, next) {
    var max = strip.scrollWidth - strip.clientWidth;
    prev.classList.toggle('is-hidden', strip.scrollLeft <= 2);
    next.classList.toggle('is-hidden', strip.scrollLeft >= max - 2);
  }

  function buildSheet(tpl, title, priceText, opts) {
    var el = document.createElement('div');
    el.className = 'ci-pick-sheet' + (opts && opts.cls ? ' ' + opts.cls : '');
    el.setAttribute('role', 'dialog');
    el.setAttribute('aria-modal', 'true');
    el.setAttribute('aria-label', title);

    var overlay = document.createElement('div');
    overlay.className = 'ci-pick-sheet__overlay';
    overlay.setAttribute('data-ci-pick-sheet-close', '');

    var panel = document.createElement('div');
    panel.className = 'ci-pick-sheet__panel';

    var head = document.createElement('div');
    head.className = 'ci-pick-sheet__header';
    var h = document.createElement('p');
    h.className = 'ci-pick-sheet__title';
    h.textContent = title;
    var x = document.createElement('button');
    x.type = 'button';
    x.className = 'ci-pick-sheet__close';
    x.setAttribute('aria-label', 'Close');
    x.setAttribute('data-ci-pick-sheet-close', '');
    x.innerHTML = X_SVG;
    head.appendChild(h);
    head.appendChild(x);

    var body = document.createElement('div');
    body.className = 'ci-pick-sheet__body';
    /* 2026-10-09 gift sheet: opts = { body: Node, footer: {type:'none'|'ghost'|'add', text}, cls }. The picks sheet
       passes no opts and is unchanged. */
    if (opts && opts.body) body.appendChild(opts.body);
    else body.appendChild(tpl.content.cloneNode(true));

    var foot = null;
    if (!opts || !opts.footer) {
      foot = document.createElement('div');
      foot.className = 'ci-pick-sheet__footer';
      var add = document.createElement('button');
      add.type = 'button';
      add.className = 'ci-pick-sheet__add';
      add.setAttribute('data-ci-pick-sheet-add', '');
      add.setAttribute('data-label', 'Add to cart' + (priceText ? ' · ' + priceText : ''));
      add.textContent = add.getAttribute('data-label');
      foot.appendChild(add);
    } else if (opts.footer.type !== 'none') {
      foot = document.createElement('div');
      foot.className = 'ci-pick-sheet__footer';
      var gb = document.createElement('button');
      gb.type = 'button';
      gb.className = 'ci-pick-sheet__add' + (opts.footer.type === 'ghost' ? ' ci-pick-sheet__add--ghost' : '');
      gb.textContent = opts.footer.text || '';
      if (opts.footer.type === 'ghost') { gb.disabled = true; gb.setAttribute('aria-disabled', 'true'); }
      else gb.setAttribute('data-ci-gift-sheet-add', '');
      foot.appendChild(gb);
    }

    panel.appendChild(head);
    panel.appendChild(body);
    if (foot) panel.appendChild(foot);
    el.appendChild(overlay);
    el.appendChild(panel);

    /* images strip: prev / next discs (CSS shows them on hover + fine pointer only) */
    var gallery = body.querySelector('.ci-pick-sheet__gallery');
    var strip = gallery && gallery.querySelector('.ci-pick-sheet__images');
    if (gallery && strip && strip.children.length > 1) {
      var prev = document.createElement('button');
      prev.type = 'button';
      prev.className = 'ci-pick-sheet__nav ci-pick-sheet__nav--prev is-hidden';
      prev.setAttribute('aria-label', 'Previous image');
      prev.tabIndex = -1;
      prev.innerHTML = CHEV_SVG;
      var next = document.createElement('button');
      next.type = 'button';
      next.className = 'ci-pick-sheet__nav ci-pick-sheet__nav--next';
      next.setAttribute('aria-label', 'Next image');
      next.tabIndex = -1;
      next.innerHTML = CHEV_SVG;
      gallery.appendChild(prev);
      gallery.appendChild(next);
      var step = function (dir) {
        var w = (strip.firstElementChild ? strip.firstElementChild.getBoundingClientRect().width : strip.clientWidth * 0.8) + 8;
        strip.scrollBy({ left: dir * w, behavior: 'smooth' });
      };
      prev.addEventListener('click', function () { step(-1); });
      next.addEventListener('click', function () { step(1); });
      strip.addEventListener('scroll', function () { updateNav(strip, prev, next); }, { passive: true });
      /* sizes are only known once the sheet is in the DOM: openSheet calls this */
      el.__ciNavInit = function () { updateNav(strip, prev, next); };
    }

    /* one delegated listener on the sheet node itself: dies with the node */
    el.addEventListener('click', function (ev) {
      var t = ev.target;
      if (!t || !t.closest) return;
      if (t.closest('[data-ci-pick-sheet-close]')) { ev.preventDefault(); closeSheet(); return; }
      var more = t.closest('[data-ci-pick-sheet-more]');
      if (more) {
        var d = el.querySelector('.ci-pick-sheet__desc');
        if (!d) return;
        var open = d.classList.toggle('is-clamped') === false;
        more.setAttribute('aria-expanded', open ? 'true' : 'false');
        more.textContent = open ? 'Show less' : 'Read more';
        return;
      }
      var revMore = t.closest('[data-ci-pick-rev-more]');
      if (revMore) {
        /* toggle, never remove the button: a detached click target reads as an outside click to the drawer's
           document listener and closed the sheet AND the drawer (QA 2026-10-13) */
        var rb = revMore.previousElementSibling;
        if (!rb) return;
        var revOpen = rb.classList.toggle('is-clamped') === false;
        revMore.setAttribute('aria-expanded', revOpen ? 'true' : 'false');
        revMore.textContent = revOpen ? 'Show less' : 'Read more';
        if (revOpen) track('ci_rec_info_review_more', trackParams({}));
        return;
      }
      if (t.closest('[data-ci-pick-sheet-add]')) { ev.preventDefault(); addFromSheet(); }
    });
    return el;
  }

  /* 2026-10-13 (Ondrej): the three most-liked 5-star reviews at the bottom of
     a pick's sheet. Okendo's public storefront API (the one its own widgets
     call), most helpful first; 5-star reviews with a written body only;
     cached per product for the page. Appended after the sheet opens, so a slow
     or failed call costs nothing. */
  var OKENDO_STORE = 'https://api.okendo.io/v1/stores/c7b2c369-e177-4ef6-acd8-d891ec1b0a13';
  var revCache = {};
  function topReviews(pid) {
    if (!revCache[pid]) {
      revCache[pid] = fetch(OKENDO_STORE + '/products/shopify-' + encodeURIComponent(pid) + '/reviews?limit=25&orderBy=' + encodeURIComponent('helpful desc'))
        .then(function (r) { return r.ok ? r.json() : { reviews: [] }; })
        .then(function (j) {
          /* a 5-star review can still carry a complaint ("looks like plastic", "a flaw in the gold"); skip those */
          var gripe = /\b(plastic|flaw|flawed|broke|broken|smaller than|disappoint\w*|fake|cheap\w*|refund|damaged|missing|scratch\w*|chipped|fell apart|not real|wasn'?t sure)\b/i;
          return (j.reviews || []).filter(function (v) {
            return v && v.rating === 5 && String(v.body || '').trim() && !gripe.test(String(v.title || '') + ' ' + String(v.body || ''));
          }).slice(0, 3);
        })
        .catch(function () { delete revCache[pid]; return []; });
    }
    return revCache[pid];
  }
  function revEsc(t) { var d = document.createElement('div'); d.textContent = String(t == null ? '' : t); return d.innerHTML; }
  function addReviews(s, c) {
    if (!c || !c.pid) return;
    topReviews(c.pid).then(function (list) {
      if (!list.length || sheet !== s || !alive()) return;
      var body = s.querySelector('.ci-pick-sheet__body');
      if (!body) return;
      var box = document.createElement('div');
      box.className = 'ci-pick-sheet__reviews';
      var html = '<p class="ci-pick-sheet__heading">Most liked reviews</p>';
      list.forEach(function (v) {
        var title = String(v.title || '').trim();
        if (/^\d\s*stars?$/i.test(title)) title = '';   /* Okendo's default "5 Stars" title says nothing */
        var who = v.reviewer && v.reviewer.displayName ? v.reviewer.displayName : '';
        html += '<div class="ci-pick-rev">' +
          '<div class="ci-pick-rev__top"><span class="ci-pick-rev__stars" role="img" aria-label="5 out of 5 stars">\u2605\u2605\u2605\u2605\u2605</span>' +
          (who ? '<span class="ci-pick-rev__who">' + revEsc(who) + '</span>' : '') +
          (v.reviewer && v.reviewer.isVerified ? '<span class="ci-pick-rev__ver">Verified buyer</span>' : '') + '</div>' +
          (title ? '<p class="ci-pick-rev__title">' + revEsc(title) + '</p>' : '') +
          '<p class="ci-pick-rev__body is-clamped">' + revEsc(String(v.body).trim()) + '</p>' +
          '<button type="button" class="ci-pick-rev__more" data-ci-pick-rev-more aria-expanded="false">Read more</button>' +
          '</div>';
      });
      box.innerHTML = html;
      body.appendChild(box);
      Array.prototype.forEach.call(box.querySelectorAll('.ci-pick-rev__body'), function (b) {
        if (b.scrollHeight <= b.clientHeight + 2) {
          b.classList.remove('is-clamped');
          if (b.nextElementSibling) b.parentNode.removeChild(b.nextElementSibling);
        }
      });
      track('ci_rec_info_reviews', trackParams({ ci_via: c.via, ci_count: list.length }));
    });
  }

  function openSheet(li, tpl, trigger, via) {
    var h = host();
    if (!h) return;
    if (sheet) removeNow();   /* a second sheet replaces the first */
    var titleEl = li.querySelector('.product-title');
    var title = (titleEl && titleEl.textContent || '').trim() || 'Product details';
    var saleEl = li.querySelector('.ci-rec-price__sale');
    var priceText = saleEl ? saleEl.textContent.trim() : '';
    var tileAdd = li.querySelector('add-to-cart.ci-rec-add');
    var props = {};
    try { props = JSON.parse((tileAdd && tileAdd.getAttribute('data-properties')) || '{}') || {}; } catch (e) { props = {}; }
    ctx = {
      li: li, trigger: trigger,
      pid: li.getAttribute('data-ci-disc-product') || '',
      rank: li.getAttribute('data-ci-disc-rank') || '',
      strip: li.closest('.ci-empty-bestsellers') ? 'empty' : 'recommended',
      variantId: tileAdd ? tileAdd.getAttribute('data-variant-id') : '',
      props: props, title: title, price: priceText, via: via
    };
    sheet = buildSheet(tpl, title, priceText);
    h.appendChild(sheet);
    /* drop the clamp and "Read more" when the description already fits */
    try {
      var d = sheet.querySelector('.ci-pick-sheet__desc');
      var mb = sheet.querySelector('[data-ci-pick-sheet-more]');
      if (d && mb && d.scrollHeight <= d.clientHeight + 2) { d.classList.remove('is-clamped'); mb.parentNode.removeChild(mb); }
    } catch (e) {}
    void sheet.offsetWidth;                /* reflow, not rAF: rAF stalls in background tabs */
    sheet.classList.add('is-open');
    if (sheet.__ciNavInit) sheet.__ciNavInit();
    try { sheet.querySelector('.ci-pick-sheet__close').focus({ preventScroll: true }); } catch (e) {}
    track('ci_rec_info_open', trackParams({ ci_via: via }));
    addReviews(sheet, ctx);
  }

  function addFromSheet() {
    if (!alive() || !ctx || ctx.busy) return;
    ctx.busy = true;
    var btn = sheet.querySelector('[data-ci-pick-sheet-add]');
    var c = ctx;
    track('ci_rec_info_add', trackParams({ ci_via: c.via }));
    var h = host();
    var tileAdd = h && h.querySelector('li[data-ci-disc-product="' + c.pid + '"] add-to-cart.ci-rec-add');
    var done = false;
    if (tileAdd && !tileAdd.hasAttribute('disabled')) {
      var prev = tileAdd.getAttribute('data-properties');
      var p = {};
      try { p = JSON.parse(prev || '{}') || {}; } catch (e) { p = {}; }
      p._upsell_path = 'info';
      try {
        tileAdd.setAttribute('data-properties', JSON.stringify(p));
        tileAdd.click();
        done = true;
      } finally {
        if (prev === null) tileAdd.removeAttribute('data-properties'); else tileAdd.setAttribute('data-properties', prev);
      }
    }
    if (!done) {
      /* the tile is gone (re-render) or mid-add: post the line ourselves */
      var props = {};
      for (var k in c.props) props[k] = c.props[k];
      props._upsell_path = 'info';
      if (c.variantId) {
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: c.variantId, quantity: 1, properties: props })
        }).then(function () { if (window.__ciDrawerRefresh) window.__ciDrawerRefresh(); })
          .catch(function () {});
      }
    }
    if (btn) {
      btn.classList.add('is-added');
      btn.innerHTML = CHECK_SVG + '<span>Added</span>';
    }
    setTimeout(function () { if (alive() && ctx === c) closeSheet(); }, 600);
  }

  /* 2026-10-09 gift sheet: same component, caller-supplied body and footer. Exposed for the gift IIFE below
     (it lives in its own scope), which wires its own clicks on the returned node. */
  function openCustom(o) {
    var h = host();
    if (!h) return null;
    if (sheet) removeNow();
    sheet = buildSheet(null, o.title, '', { body: o.body, footer: o.footer, cls: o.cls });
    ctx = { trigger: o.trigger || null, gift: true };
    h.appendChild(sheet);
    try {
      var d = sheet.querySelector('.ci-pick-sheet__desc');
      var mb = sheet.querySelector('[data-ci-pick-sheet-more]');
      if (d && mb && d.scrollHeight <= d.clientHeight + 2) { d.classList.remove('is-clamped'); mb.parentNode.removeChild(mb); }
    } catch (e) {}
    void sheet.offsetWidth;
    sheet.classList.add('is-open');
    if (sheet.__ciNavInit) sheet.__ciNavInit();
    try { sheet.querySelector('.ci-pick-sheet__close').focus({ preventScroll: true }); } catch (e) {}
    return sheet;
  }
  window.__ciSheetApi = { open: openCustom, close: closeSheet, remove: removeNow, alive: alive, node: function () { return sheet; } };

  /* open: photo or title on a pick tile */
  document.addEventListener('click', function (ev) {
    try {
      var t = ev.target;
      if (!t || !t.closest) return;
      var trg = t.closest('[data-ci-pick-info]');
      if (!trg) return;
      var h = host();
      if (!h || !h.contains(trg)) return;
      var li = trg.closest('li[data-ci-disc-product]');
      var tpl = li && li.querySelector('template[data-ci-pick-info-content]');
      if (!tpl) return;                /* no template: let the link behave as before */
      ev.preventDefault();             /* stops the navigation to the product page */
      openSheet(li, tpl, trg, trg.getAttribute('data-ci-pick-info') || '');
    } catch (e) {}
  }, true);

  /* Escape closes the sheet only; swallow the keyup so the theme's
     onKeyUpEscape does not close the whole drawer behind it. Tab stays inside. */
  document.addEventListener('keydown', function (ev) {
    if (!alive()) return;
    if (ev.key === 'Escape' || ev.code === 'Escape') {
      ev.preventDefault();
      ev.stopPropagation();
      escSwallow = true;
      setTimeout(function () { escSwallow = false; }, 1500);
      closeSheet();
      return;
    }
    if (ev.key === 'Tab') {
      var f = sheet.querySelectorAll('button:not([tabindex="-1"]), [tabindex="0"]');
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (!sheet.contains(document.activeElement)) { ev.preventDefault(); first.focus(); }
      else if (ev.shiftKey && document.activeElement === first) { ev.preventDefault(); last.focus(); }
      else if (!ev.shiftKey && document.activeElement === last) { ev.preventDefault(); first.focus(); }
    }
  }, true);
  window.addEventListener('keyup', function (ev) {
    if (!escSwallow) return;
    if (ev.key === 'Escape' || ev.code === 'Escape') { escSwallow = false; ev.stopPropagation(); }
  }, true);

  /* the drawer itself closing takes the sheet with it */
  document.addEventListener('toggle', function (ev) {
    var det = ev.target;
    if (!det || !det.classList || !det.classList.contains('cart-drawer-container')) return;
    if (!det.hasAttribute('open') && sheet) removeNow();
  }, true);
})();

/* ---- 2026-10-09 GIFT MILESTONE (ARM ONLY; spec: shopify-theme/gift-drawer-1009/SPEC.md) ----
   A free gift at 58.85 USD of non-gift subtotal; free shipping stays at 78.85. One gift at a time, picked by
   co-purchase score (window.__ciGiftRank, snippets/ci-gift-rank.liquid), kept for the cart session once chosen.

   How it runs (no MutationObserver, no /cart.js reads):
   - sections/mini-cart.liquid renders a JSON island (script[data-ci-gift-state]) with the threshold, the
     qualifying subtotal, the gift lines, the non-gift lines newest first and the three candidates, plus the
     bar marker, the locked card and the gift line as plain Liquid. This file only READS the island on the
     render seams that already exist (ci:cart:rerendered from the renderContents patch / doRefresh,
     cartdrawer:opened from the lazy fetch, cart:updated from cart.js qty+remove, drawer open) and decides.
   - at most ONE cart call per render, in this order: collapse extra gift lines / set qty back to 1, auto
     remove under the threshold, auto add over it, then (once per cart) the _ci_gift_arm attribute. Every call
     asks for the drawer sections in the same response, so the result paints without another round trip.
     A sliding 60s window refuses a 7th call (the store rate-limits cart calls at ~10/min per session).
   - the Liquid default gift is the first available candidate; when the score picks another, patchUI() rewrites
     the marker, the card and the message word synchronously inside the render event, before paint.
   - gift removed by the shopper = sessionStorage ci_gift_declined=1: the card then reads "Add your free X" with an
     Add button and nothing is auto-added again. Cleared when the cart empties.
   - sessionStorage: ci_gift_choice (product id, set by the engine's pick and never changed from the UI), ci_gift_declined,
     ci_gift_arm_set, ci_gift_acts (call times), ci_gift_unavailable + ci_gift_session (the fail-closed guard below).
   - money is the store's own whole-unit format (like the cart line prices); gap amounts round up.
   - window.__ciGiftCalls records every cart mutation this file makes (QA counts them per render). */
(function () {
  'use strict';
  var root = document.documentElement;
  var K = { choice: 'ci_gift_choice', declined: 'ci_gift_declined', armSet: 'ci_gift_arm_set', acts: 'ci_gift_acts', unavail: 'ci_gift_unavailable', sess: 'ci_gift_session' };
  var SECTIONS = ['mini-cart', 'cart-icon-bubble', 'mobile-cart-icon-bubble'];
  var mem = {};
  var busy = false;
  var failed = {};
  var seenThisOpen = false;
  var stateNode = null, stateObj = null;

  function ss(k, v) {
    try {
      if (v === undefined) { var r = sessionStorage.getItem(k); return r === null ? (mem[k] || null) : r; }
      if (v === null) { sessionStorage.removeItem(k); delete mem[k]; }
      else { sessionStorage.setItem(k, v); mem[k] = v; }
    } catch (e) {
      if (v === undefined) return mem[k] || null;
      if (v === null) delete mem[k]; else mem[k] = v;
    }
    return null;
  }
  function track(name, params) {
    try { if (window.__ciTrack) window.__ciTrack(name, params); } catch (e) {}
    try { (window.igEvents = window.igEvents || []).push({ event: name }); } catch (e2) {}
  }
  function host() { return document.getElementById('mini-cart'); }
  function enabled() { return root.classList.contains('ci-native-cart'); }
  function esc(s) { return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }
  function short(t) { return String(t || '').split(/ – | - |,/)[0].trim(); }
  /* the store's own money format (whole units, like the cart line prices); up = round UP to the next whole unit
     (gap amounts: a $0.40 gap reads "$1"). Threshold logic stays on exact cents, this only formats. */
  function money(S, c, up) {
    var v = up ? Math.ceil(Math.round(c) / 100 - 1e-9) : Math.round(c / 100);
    return ((S && S.sym) || '$') + String(Math.max(0, v)).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
  function weight(i) { return Math.max(0.4, 1 - 0.1 * i); }

  /* ---------- state ---------- */
  function readState() {
    var h = host();
    var n = h && h.querySelector('script[data-ci-gift-state]');
    if (!n) { stateNode = null; stateObj = null; return null; }
    if (n === stateNode && stateObj) return stateObj;
    try { stateObj = JSON.parse(n.textContent); stateNode = n; } catch (e) { stateObj = null; stateNode = null; }
    return stateObj;
  }
  function giftByPid(S, pid) {
    for (var i = 0; i < S.g.length; i++) if (S.g[i].pid === pid) return S.g[i];
    return null;
  }
  function isPaid(S, pid) {
    for (var i = 0; i < S.lines.length; i++) if (S.lines[i].pid === pid) return true;
    return false;
  }
  function usable(S, g) { return !!(g && g.a === 1 && !failed[g.pid] && !isPaid(S, g.pid)); }
  function score(S, g) {
    var R = window.__ciGiftRank || {}, s = 0;
    for (var i = 0; i < S.lines.length; i++) {
      var r = R[S.lines[i].pid];
      if (r && r[g.pid]) s += r[g.pid] * weight(i);
    }
    return s;
  }
  /* the gift this cart shows: the gift line's own product, else the kept choice while still valid, else the
     best score (ties and no signal fall back to the candidate order, cheapest COGS first). */
  function chooseGift(S) {
    if (S.gl.length) {
      var lg = giftByPid(S, S.gl[0].pid);
      if (lg) { ss(K.choice, lg.pid); return lg; }
    }
    var kept = giftByPid(S, ss(K.choice));
    if (kept && usable(S, kept)) return kept;
    var best = null, bestScore = -1;
    for (var i = 0; i < S.g.length; i++) {
      var g = S.g[i];
      if (!usable(S, g)) continue;
      var sc = score(S, g);
      if (sc > bestScore + 1e-9) { best = g; bestScore = sc; }
    }
    if (best && S.lines.length) ss(K.choice, best.pid);
    return best;
  }

  /* ---------- cart calls ---------- */
  function actionsAllowed() {
    var now = Date.now(), a = [];
    try { a = JSON.parse(ss(K.acts) || '[]') || []; } catch (e) { a = []; }
    a = a.filter(function (t) { return now - t < 60000; });
    return a.length < 6;
  }
  function noteAction() {
    var now = Date.now(), a = [];
    try { a = JSON.parse(ss(K.acts) || '[]') || []; } catch (e) { a = []; }
    a = a.filter(function (t) { return now - t < 60000; });
    a.push(now);
    ss(K.acts, JSON.stringify(a));
  }
  function post(url, body, why, noRender) {
    noteAction();
    (window.__ciGiftCalls = window.__ciGiftCalls || []).push({ t: Date.now(), url: url, why: why });
    if (!noRender) body.sections = SECTIONS;
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) {
        return r.json().then(function (j) { return { ok: r.ok, status: r.status, j: j }; }, function () { return { ok: false, status: r.status, j: {} }; });
      });
  }
  function applySections(j) {
    var sec = j && j.sections, any = false;
    if (!sec) return false;
    SECTIONS.forEach(function (id) {
      var t = document.getElementById(id), html = sec[id];
      if (!t || !html) return;
      var inner = new DOMParser().parseFromString(html, 'text/html').querySelector('.shopify-section');
      if (inner) { t.innerHTML = inner.innerHTML; any = true; }
    });
    return any;
  }
  function finishRender(j) {
    if (applySections(j)) document.dispatchEvent(new CustomEvent('ci:cart:rerendered', { detail: { source: 'refresh' } }));
    else if (window.__ciDrawerRefresh) window.__ciDrawerRefresh();
  }

  function addGift(g, via) {
    if (busy || !g) return;
    busy = true;
    post('/cart/add.js', { id: g.vid, quantity: 1, properties: { _ci_gift: 'milestone' } }, 'gift_add:' + via).then(function (res) {
      busy = false;
      if (res.ok) {
        ss(K.choice, g.pid);
        if (via === 'declined_card') { ss(K.declined, null); track('ci_gift_declined_add', { ci_gift: g.h }); }
        else track('ci_gift_auto_add', { ci_gift: g.h });
        finishRender(res.j);
      } else {
        failed[g.pid] = true;          /* sold out / rejected: the next tick picks another candidate */
        track('ci_gift_add_failed', { ci_gift: g.h, ci_status: res.status });
        setTimeout(tick, 0);
      }
    }, function () { busy = false; failed[g.pid] = true; });
  }
  function removeLine(S, idx, via, qty) {
    if (busy) return;
    var gl = S.gl[idx], g = giftByPid(S, gl.pid);
    busy = true;
    post('/cart/change.js', { id: gl.k, quantity: qty }, 'gift_' + (qty === 0 ? 'remove' : 'qty1') + ':' + via).then(function (res) {
      busy = false;
      if (res.ok) {
        if (qty === 0) track('ci_gift_removed', { ci_gift: g ? g.h : gl.pid, ci_via: via });
        finishRender(res.j);
      }
    }, function () { busy = false; });
  }
  /* 2026-10-12: several gift lines out in ONE /cart/update.js (keys = the line keys to zero) */
  function removeGiftLines(S, keys, via) {
    if (busy || !keys || !keys.length) return;
    var updates = {}, i;
    for (i = 0; i < keys.length; i++) updates[keys[i]] = 0;
    var first = S.gl[0], g = first ? giftByPid(S, first.pid) : null;
    busy = true;
    post('/cart/update.js', { updates: updates }, 'gift_remove:' + via).then(function (res) {
      busy = false;
      if (res.ok) {
        track('ci_gift_removed', { ci_gift: g ? g.h : (first ? first.pid : ''), ci_via: via });
        finishRender(res.j);
      }
    }, function () { busy = false; });
  }
  function setArmAttr() {
    if (busy) return;
    ss(K.armSet, '1');
    busy = true;
    post('/cart/update.js', { attributes: { _ci_gift_arm: '1' } }, 'arm_attr', true).then(function () { busy = false; }, function () { busy = false; });
  }
  /* ---------- markup the Liquid default also renders (keep in sync with snippets/free-shipping.liquid) ---------- */
  var CHEV = '<svg class="ci-gc__chev" viewBox="0 0 8 12" width="7" height="11" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M1.5 1.5 6 6l-4.5 4.5"/></svg>';
  function cardInner(S, g, mode) {
    var kind = String(g.k || 'gift').toLowerCase();
    var cap = mode === 'declined' ? 'Add your free ' + kind : 'Free ' + kind + ' at ' + S.thl;
    var right = mode === 'declined'
      ? '<button type="button" class="ci-gc__addbtn" data-ci-gift-add>Add</button>'
      : '<s>' + esc(money(S, g.s)) + '</s>' + CHEV;
    return '<span class="ci-gc__th"><img src="' + esc(g.i) + '" alt="" width="56" height="56" loading="eager"></span>' +
      '<span class="ci-gc__b"><span class="ci-gc__cap">' + esc(cap) + '</span><span class="ci-gc__nm">' + esc(g.t) + '</span></span>' +
      '<span class="ci-gc__pr">' + right + '</span>';
  }
  function setCard(card, S, g, mode) {
    if (card.getAttribute('data-pid') === g.pid && card.getAttribute('data-mode') === mode) return;
    card.innerHTML = cardInner(S, g, mode);
    card.setAttribute('data-pid', g.pid);
    card.setAttribute('data-mode', mode);
    card.setAttribute('role', mode === 'declined' ? 'group' : 'button');
    card.setAttribute('aria-label', mode === 'declined' ? 'Add your free ' + String(g.k).toLowerCase() : 'Free ' + String(g.k).toLowerCase() + ' at ' + S.thl + ', tap for details');
    if (mode === 'declined') card.removeAttribute('tabindex'); else card.setAttribute('tabindex', '0');
  }
  function patchUI(S, g, over) {
    var h = host();
    var band = h && h.querySelector('.free-shipping.ci-fs--gift');
    if (!band) return;
    var hasLine = S.gl.length > 0;
    var card = band.querySelector('.ci-gc');
    var marker = band.querySelector('.ci-gm');
    if (hasLine || !g) { if (card) card.hidden = true; return; }
    if (!over) {
      var kw = band.querySelector('.ci-gift-kind');
      if (kw && kw.textContent !== g.k) kw.textContent = g.k;
      if (marker && marker.getAttribute('data-pid') !== g.pid) {
        marker.setAttribute('data-pid', g.pid);
        marker.setAttribute('aria-label', 'Free ' + String(g.k).toLowerCase() + ' at ' + S.thl + ', tap for details');
        var im = marker.querySelector('.ci-gm__dot img');
        if (im) im.src = g.m || g.i;
      }
      if (card) { setCard(card, S, g, 'locked'); card.hidden = false; }
    } else if (card) {
      if (ss(K.declined)) { setCard(card, S, g, 'declined'); card.hidden = false; }
      else card.hidden = true;
    }
  }

  /* ---------- fail-closed guard ----------
     The gift must never be CHARGED. While the free-gift discount is not live (or Shopify drops it, e.g. next to the
     35% bracelet sale, which does not combine), the gift line comes back with a price. The first time a render shows
     a gift line with final_line_price > 0 (confirmed with one /cart.js read), ONE /cart/update.js removes the line and
     sets the cart attribute _ci_gift_off=1; the Liquid then renders the plain free-shipping bar (no marker, card or
     gift line) and this file stops adding gifts for the session (sessionStorage ci_gift_unavailable).
     The flag is PER SESSION, not per cart: the first render of a new session clears a _ci_gift_off left on the cart by
     an earlier session (one /cart/update.js), and a flag that came from a cart holding sale-discounted lines
     (ci_gift_unavailable = 'sale', the 35% bracelet sale does not combine with the gift discount) is released as soon
     as the cart holds none, so the gift is probed again. Otherwise one probe per session: no add/remove loop. */
  var guardBusy = false, offPosted = false;
  function guardOff(S) {
    if (guardBusy || busy || !actionsAllowed()) return;
    var gl = S.gl[0];
    if (!gl) return;
    guardBusy = true;
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
      var charged = null;
      (cart.items || []).forEach(function (it) {
        if (it.properties && it.properties._ci_gift === 'milestone' && it.final_line_price > 0) charged = it;
      });
      if (!charged) { guardBusy = false; return; }            /* really free now: nothing to do */
      var firstTime = !ss(K.unavail);
      var saleCart = (cart.items || []).some(function (it) {
        return !(it.properties && it.properties._ci_gift) && it.final_line_price < it.original_line_price;
      });
      ss(K.sess, '1');
      ss(K.unavail, saleCart ? 'sale' : '1');
      var updates = {};
      (cart.items || []).forEach(function (it) {
        if (it.properties && it.properties._ci_gift === 'milestone') updates[it.key] = 0;
      });
      return post('/cart/update.js', { updates: updates, attributes: { _ci_gift_off: '1' } }, 'gift_guard').then(function (res) {
        guardBusy = false;
        if (firstTime) track('ciGiftUnavailable', { ci_gift: String(gl.pid) });
        if (res.ok) finishRender(res.j);
      });
    }).catch(function () { guardBusy = false; });
  }

  /* clear _ci_gift_off from the cart (new session, or the sale lines are gone): the gift bar comes back on the render */
  var clearTried = false;
  function clearOff() {
    if (clearTried || busy || !actionsAllowed()) return;
    clearTried = true;
    post('/cart/update.js', { attributes: { _ci_gift_off: '' } }, 'gift_off_clear').then(function (res) { if (res.ok) finishRender(res.j); });
  }
  function noSaleLines(S) {
    for (var i = 0; i < S.lines.length; i++) if (S.lines[i].c < S.lines[i].o) return false;
    return true;
  }

  /* 2026-10-12: a gift line that must come out never waits for the shopper's next click: when the 60s call window is
     full, tick again the moment the oldest call leaves it (the hidden stale line is still in the cart until then) */
  var retryT = null;
  function retryWhenAllowed() {
    if (retryT) return;
    var a = [], now = Date.now();
    try { a = JSON.parse(ss(K.acts) || '[]') || []; } catch (e) { a = []; }
    a = a.filter(function (t) { return now - t < 60000; });
    var wait = a.length ? Math.max(100, 60000 - (now - a[0]) + 100) : 100;
    retryT = setTimeout(function () { retryT = null; tick(); }, wait);
  }

  /* ---------- the render decision ---------- */
  function tick() {
    try {
      if (!enabled() || busy) return;
      var S = readState(), h = host();
      if (!S || !S.en) {
        /* no island: empty cart (new session), or a market without the milestone */
        if (h && h.querySelector('.mini-cart.is-empty')) { ss(K.choice, null); ss(K.declined, null); ss(K.armSet, null); }
        return;
      }
      /* guard: a charged gift line comes out, whatever the state; once off (cart attribute or session flag) nothing
         is added or removed again */
      /* 2026-10-12: under the threshold every gift line comes out in ONE call (the Function only frees a gift over the
         threshold, so a gift line there is charged or about to be; it is a normal crossing-down and the gift stays on
         offer). A qty split on the cart page can leave a free line plus a charged one, so dedupe keeps the free one
         BEFORE the guard. Only a single charged line over the threshold trips the guard (the discount is off). */
      if (S.gl.length && S.q < S.th) {
        /* 2026-10-12: the Liquid already hides this stale line and renders the locked bar; patch the marker and card
           to the kept gift now so they do not swap pictures when the removal render lands */
        try { var S0 = {}, sk; for (sk in S) S0[sk] = S[sk]; S0.gl = []; patchUI(S0, chooseGift(S0), false); } catch (e0) {}
        if (actionsAllowed()) removeGiftLines(S, S.gl.map(function (x) { return x.k; }), 'auto'); else retryWhenAllowed();
        return;
      }
      if (S.gl.length > 1) {
        if (actionsAllowed()) {
          var keep = 0, di, dk = [];
          for (di = 0; di < S.gl.length; di++) if (S.gl[di].p === 0) { keep = di; break; }
          for (di = 0; di < S.gl.length; di++) if (di !== keep) dk.push(S.gl[di].k);
          removeGiftLines(S, dk, 'dedupe');
        } else retryWhenAllowed();
        return;
      }
      if (S.gl.length === 1 && S.gl[0].q > 1) { if (actionsAllowed()) removeLine(S, 0, 'qty', 1); else retryWhenAllowed(); return; }
      if (S.gl.length === 1 && S.gl[0].p > 0) { guardOff(S); return; }
      if (!ss(K.sess)) {                       /* first render of this session: an earlier session's flag does not carry over */
        ss(K.sess, '1');
        if (S.off) { clearOff(); return; }
      }
      if (ss(K.unavail) === 'sale' && noSaleLines(S)) {   /* the flag came from a sale cart and the sale lines are gone: probe again */
        ss(K.unavail, null);
        if (S.off) { clearOff(); return; }
      }
      if (S.off || ss(K.unavail)) {
        if (!S.off && !offPosted && actionsAllowed()) {           /* session flag set but the cart attribute is not: set it once so the bar falls back */
          offPosted = true;
          post('/cart/update.js', { attributes: { _ci_gift_off: '1' } }, 'gift_off_attr').then(function (res) { if (res.ok) finishRender(res.j); });
        }
        return;
      }
      var over = S.q >= S.th;
      var g = chooseGift(S);
      patchUI(S, g, over);
      noteMarkerSeen(S);
      if (!actionsAllowed()) return;
      if (!S.gl.length && over && !ss(K.declined) && g) { addGift(g, 'auto'); return; }
      if (!S.arm && !ss(K.armSet)) setArmAttr();
    } catch (e) {}
  }
  function noteMarkerSeen(S) {
    if (seenThisOpen) return;
    var det = document.querySelector('.cart-drawer-container');
    if (!det || !det.hasAttribute('open')) return;
    var m = host() && host().querySelector('.ci-gm');
    if (!m) return;
    seenThisOpen = true;
    var g = giftByPid(S, m.getAttribute('data-pid'));
    track('ci_gift_marker_seen', { ci_gift: g ? g.h : '', ci_gap: Math.max(0, S.th - S.q) });
  }

  document.addEventListener('ci:cart:rerendered', tick);
  document.addEventListener('cartdrawer:opened', tick);
  document.addEventListener('cart:updated', tick);
  document.addEventListener('toggle', function (e) {
    var det = e.target;
    if (!det || !det.classList || !det.classList.contains('cart-drawer-container')) return;
    seenThisOpen = false;
    if (det.hasAttribute('open')) tick();
  }, true);

  /* ---------- cart page sanitizer (2026-10-12) ----------
     /cart has no drawer logic: dropping under the threshold there left the gift charged at full price, and the gift
     row's stepper (now gone from the row) could make a second, charged gift-tagged line. sections/main-cart-items.liquid
     renders an island script[data-ci-cart-gift] = { th, q, gl:[{k,q,p}] } (inside .js-contents, so cart.js replaces it
     with the rows). Same decision as tick(): under the threshold every gift line comes out; else keep ONE gift line
     (the free one); else a qty above 1 goes back to 1; else a charged gift line over the threshold (the discount is
     not applying) is just taken out. It never sets _ci_gift_off or any session flag. One /cart/update.js call that
     also returns the cart page sections, which are swapped in place; an emptied cart reloads. At most 2 runs per
     load / cart:updated (the re-run reads the island of the fresh render). */
  var cpBusy = false;
  function cartPageIsland() {
    var n = document.querySelector('script[data-ci-cart-gift]');
    if (!n) return null;
    try { return JSON.parse(n.textContent); } catch (e) { return null; }
  }
  function cartPageSectionIds() {
    var ids = [], els = document.querySelectorAll('[id^="shopify-section-"]'), i, id;
    for (i = 0; i < els.length; i++) {
      id = els[i].id;
      if (id.indexOf('cart-items') > -1 || id.indexOf('cart-footer') > -1) ids.push(id.slice('shopify-section-'.length));
    }
    if (document.getElementById('cart-icon-bubble')) ids.push('cart-icon-bubble');
    return ids;
  }
  function cartPageApply(j, ids) {
    var sec = j && j.sections;
    if (!sec) return;
    ids.forEach(function (id) {
      var html = sec[id];
      if (!html) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var inner = doc.querySelector('.shopify-section') || doc.getElementById('shopify-section-' + id);
      var t = id === 'cart-icon-bubble' ? document.getElementById('cart-icon-bubble') : document.getElementById('shopify-section-' + id);
      if (inner && t) t.innerHTML = inner.innerHTML;
    });
  }
  /* ---------- cart page auto-add (2026-10-16, Ondrej: "prepare this fix") ----------
     The drawer adds the gift when it renders; a shopper who goes from /cart to checkout without opening the drawer
     never got it (order audit 10-15: 7 of 16 qualifying arm orders without the gift had no drawer render). When the
     /cart island shows the threshold met and no gift line, read the drawer's OWN gift island once through the
     Section Rendering API (same Liquid, same candidates, same off rule as tick()) and add the chosen gift, asking for
     the cart page sections in the same response. Never after the shopper removed the gift (ci_gift_declined), never
     while the gift is off for the session (ci_gift_unavailable or _ci_gift_off). One try per crossing: re-armed only
     when the cart drops under the threshold. Holds the drawer's busy flag so tick() cannot add a second gift. */
  var cpAddTried = false;
  function cartPageAdd() {
    if (cpAddTried || cpBusy || busy || !enabled()) return;
    if (ss(K.declined) || ss(K.unavail) || !actionsAllowed()) return;
    cpAddTried = true;
    cpBusy = true;
    fetch('/?sections=mini-cart', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (sec) {
        var html = sec && sec['mini-cart'], S = null;
        var node = html ? new DOMParser().parseFromString(html, 'text/html').querySelector('script[data-ci-gift-state]') : null;
        try { S = node ? JSON.parse(node.textContent) : null; } catch (e) { S = null; }
        if (!S || !S.en || S.off || (S.gl && S.gl.length) || S.q < S.th) { cpBusy = false; return; }
        var g = chooseGift(S);
        if (!g || busy) { cpBusy = false; return; }
        var ids = cartPageSectionIds();
        busy = true;
        noteAction();
        (window.__ciGiftCalls = window.__ciGiftCalls || []).push({ t: Date.now(), url: '/cart/add.js', why: 'gift_add:cart_page' });
        return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: g.vid, quantity: 1, properties: { _ci_gift: 'milestone' }, sections: ids, sections_url: window.location.pathname }) })
          .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, status: r.status, j: j }; }, function () { return { ok: false, status: r.status, j: {} }; }); })
          .then(function (res) {
            busy = false; cpBusy = false;
            if (!res.ok) { failed[g.pid] = true; track('ci_gift_add_failed', { ci_gift: g.h, ci_status: res.status, ci_via: 'cart_page' }); return; }
            ss(K.choice, g.pid);
            track('ci_gift_auto_add', { ci_gift: g.h, ci_via: 'cart_page' });
            cartPageApply(res.j, ids);
            try { if (window.__ciDrawerRefresh) window.__ciDrawerRefresh(); } catch (e2) {}
            cartPageTick(1);
          });
      })
      .catch(function () { busy = false; cpBusy = false; });
  }
  function cartPageTick(n) {
    n = n || 0;
    try {
      if (cpBusy || n >= 2) return;
      var I = cartPageIsland();
      if (!I || !(I.th > 0)) return;
      /* 2026-10-16: no gift line on /cart. Under the threshold re-arms the one add try; over it, try the add once */
      if (!I.gl || !I.gl.length) { if (I.q < I.th) cpAddTried = false; else if (n === 0) cartPageAdd(); return; }
      var gl = I.gl, updates = {}, removed = false, i, keep = 0;
      if (I.q < I.th) {
        for (i = 0; i < gl.length; i++) updates[gl[i].k] = 0;
        removed = true;
      } else if (gl.length > 1) {
        for (i = 0; i < gl.length; i++) if (gl[i].p === 0) { keep = i; break; }
        for (i = 0; i < gl.length; i++) if (i !== keep) updates[gl[i].k] = 0;
        removed = true;
      } else if (gl[0].q > 1) {
        updates[gl[0].k] = 1;
      } else if (gl[0].p > 0) {
        updates[gl[0].k] = 0;
        removed = true;
      } else return;
      if (!actionsAllowed()) return;
      var ids = cartPageSectionIds();
      var via = I.q < I.th ? 'auto' : (gl.length > 1 ? 'dedupe' : (gl[0].q > 1 ? 'qty' : 'charged'));
      cpBusy = true;
      noteAction();
      (window.__ciGiftCalls = window.__ciGiftCalls || []).push({ t: Date.now(), url: '/cart/update.js', why: 'cart_page:' + via });
      fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ updates: updates, sections: ids, sections_url: window.location.pathname }) })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }, function () { return { ok: false, j: {} }; }); })
        .then(function (res) {
          cpBusy = false;
          if (!res.ok) return;
          if (removed) track('ci_gift_removed', { ci_gift: String(gl[0].k).split(':')[0], ci_via: 'cart_page' });
          if (res.j && res.j.item_count === 0) { window.location.reload(); return; }
          cartPageApply(res.j, ids);
          try { if (window.__ciDrawerRefresh) window.__ciDrawerRefresh(); } catch (e2) {}
          cartPageTick(n + 1);
        }, function () { cpBusy = false; });
    } catch (e) { cpBusy = false; }
  }
  document.addEventListener('cart:updated', function () { cartPageTick(0); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { cartPageTick(0); });
  else cartPageTick(0);

  /* ---------- unlock animations (2026-10-09, arm only; Ondrej approved) ----------
     1. bar tween: on every cart render the fill glides from its old width to the new one (400ms,
        cubic-bezier(.2,.8,.2,1), transform only: the element already has its NEW width, a scaleX(old/new) -> 1 runs
        on the fill and a translateX on the knob; no width transition).
     2. countdown: the "$X more" amount counts down old -> new in whole dollars (rounded up like the bar copy). It
        only ever counts DOWN, so it never shows less than the real gap; a growing gap just shows the new value.
     3. unlock moment, only when a threshold is crossed UPWARD by a cart change in this page (never on load, never on
        a drawer open; every upward crossing since 2026-10-13, Ondrej: "not limit to one per session"):
        knob pop, one canvas confetti burst (inside the band, never fixed or full-viewport, removed when done), the
        message fades in with a tick. The gift fires when its line really arrives free, never on a charged line.
     prefers-reduced-motion: nothing animates and no canvas is made; the events still fire.
     State lives in fx (numbers only); the DOM is replaced on every render. */
  var fx = { prev: null, downAt: { gift: 0, ship: 0 }, giftPending: 0, hlUntil: 0 };
  function reducedMotion() {
    try { return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches); } catch (e) { return false; }
  }
  function ease(t) {                    /* cubic-bezier(.2,.8,.2,1), solved by bisection on x */
    var lo = 0, hi = 1, x = t, u = t, i;
    for (i = 0; i < 14; i++) {
      u = (lo + hi) / 2;
      x = 3 * u * (1 - u) * (1 - u) * .2 + 3 * u * u * (1 - u) * .2 + u * u * u;
      if (x < t) lo = u; else hi = u;
    }
    return 3 * u * (1 - u) * (1 - u) * .8 + 3 * u * u * (1 - u) * 1 + u * u * u;
  }
  function fxState() {
    var h = host(), band = h && h.querySelector('.free-shipping');
    if (!band) return null;
    var pr = band.querySelector('.free-shipping__progress');
    var pct = pr ? parseFloat(String(pr.style.getPropertyValue('--progress') || '').replace('%', '')) : NaN;
    var amt = band.querySelector('.ci-fs-msg > b');
    var gap = amt ? parseInt(String(amt.textContent).replace(/[^0-9]/g, ''), 10) : NaN;
    var S = readState();
    var kind = band.classList.contains('ci-fs--ok') ? 'ok' : (band.classList.contains('ci-fs--gift-locked') ? 'gift' : 'ship');
    return { pct: pct, gap: gap, kind: kind, ok: kind === 'ok',
      over: S && S.en ? S.q >= S.th : null,
      line: !!(S && S.gl && S.gl.length), free: !!(S && S.gl && S.gl.length && S.gl[0].p === 0),
      off: !!(S && (S.off || ss(K.unavail))) };
  }
  function fmtGap(n, tpl) {
    return String(tpl).replace(/[0-9][0-9,]*/, String(n).replace(/\B(?=(\d{3})+(?!\d))/g, ','));
  }
  function runTween(band, prev, cur) {
    var pr = band.querySelector('.free-shipping__progress');
    if (!pr || !(cur.pct > 1) || !(prev.pct >= 0)) return;
    var s0 = prev.pct / cur.pct;
    var dx = (prev.pct - cur.pct) / 100 * pr.getBoundingClientRect().width;
    pr.style.setProperty('--ci-s0', String(s0));
    pr.style.setProperty('--ci-dx', dx.toFixed(1) + 'px');
    pr.classList.add('ci-fx-tween');
    setTimeout(function () { pr.classList.remove('ci-fx-tween'); pr.style.removeProperty('--ci-s0'); pr.style.removeProperty('--ci-dx'); }, 480);
  }
  function runCountdown(band, prev, cur) {
    var amt = band.querySelector('.ci-fs-msg > b');
    if (!amt || !(prev.gap > cur.gap)) return;
    var node = amt.querySelector('bdi') || amt;
    var tpl = node.textContent;
    node.textContent = fmtGap(prev.gap, tpl);
    var t0 = null;
    function step(ts) {
      if (t0 === null) t0 = ts;
      var t = Math.min(1, (ts - t0) / 400), v = Math.ceil(cur.gap + (prev.gap - cur.gap) * (1 - ease(t)) - 1e-9);
      if (t >= 1) v = cur.gap;
      if (node.isConnected) node.textContent = fmtGap(Math.max(cur.gap, v), tpl);
      if (t < 1 && node.isConnected) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }
  function burst(band, colors, pct) {
    var pr = band.querySelector('.free-shipping__progress');
    if (!pr) return;
    var old = band.querySelector('canvas.ci-fx-canvas');
    if (old) old.remove();
    var b = band.getBoundingClientRect(), r = pr.getBoundingClientRect();
    var w = Math.min(Math.round(b.width), 402), hh = 260, dpr = Math.min(window.devicePixelRatio || 1, 2);
    var cv = document.createElement('canvas');
    cv.className = 'ci-fx-canvas';
    cv.setAttribute('aria-hidden', 'true');
    cv.width = Math.round(w * dpr); cv.height = Math.round(hh * dpr);
    cv.style.width = w + 'px'; cv.style.height = hh + 'px';
    cv.style.left = '0px'; cv.style.top = Math.round(r.top - b.top + r.height / 2 - 70) + 'px';
    band.appendChild(cv);
    var ctx = cv.getContext('2d');
    if (!ctx) { cv.remove(); return; }
    ctx.scale(dpr, dpr);
    var ox = Math.max(8, Math.min(w - 8, r.left - b.left + r.width * (pct / 100))), oy = 70;
    var parts = [], i;
    for (i = 0; i < 28; i++) {
      var a = -Math.PI / 2 + (Math.random() - .5) * 2.4, sp = 170 + Math.random() * 260;
      parts.push({ x: ox, y: oy, vx: Math.cos(a) * sp, vy: Math.sin(a) * sp, rot: Math.random() * 6.28, vr: (Math.random() - .5) * 14,
        c: colors[i % colors.length], circle: i % 3 === 0 });
    }
    var t0 = null, last = 0, LIFE = 1080, G = 950;
    function frame(ts) {
      if (t0 === null) { t0 = ts; last = ts; }
      var el = ts - t0, dt = Math.min(.05, (ts - last) / 1000);
      last = ts;
      ctx.clearRect(0, 0, w, hh);
      if (el >= LIFE || !cv.isConnected) { cv.remove(); return; }
      var alpha = el > LIFE - 220 ? Math.max(0, (LIFE - el) / 220) : 1;
      for (var k = 0; k < parts.length; k++) {
        var q = parts[k];
        q.vy += G * dt; q.x += q.vx * dt; q.y += q.vy * dt; q.rot += q.vr * dt;
        ctx.save();
        ctx.globalAlpha = alpha;
        ctx.translate(q.x, q.y);
        ctx.rotate(q.rot);
        ctx.fillStyle = q.c;
        if (q.circle) { ctx.beginPath(); ctx.arc(0, 0, 3, 0, 6.2832); ctx.fill(); }
        else ctx.fillRect(-3, -5, 6, 10);
        ctx.restore();
      }
      requestAnimationFrame(frame);
    }
    requestAnimationFrame(frame);
    setTimeout(function () { if (cv.isConnected) cv.remove(); }, LIFE + 250);     /* backstop: a paused tab never leaves it behind */
  }
  function unlockMoment(band, cur, which) {
    var gift = which.indexOf('gift') > -1, ship = which.indexOf('ship') > -1;
    if (gift) { ss('ci_fx_gift', '1'); track('ciUnlockGift', {}); fx.hlUntil = Date.now() + 8000; }
    if (ship) { ss('ci_fx_ship', '1'); track('ciUnlockShip', {}); }
    if (reducedMotion()) return;
    var pr = band.querySelector('.free-shipping__progress'), msg = band.querySelector('.ci-fs-msg');
    if (pr) { pr.classList.add('ci-fx-pop'); setTimeout(function () { pr.classList.remove('ci-fx-pop'); }, 520); }
    if (msg) { msg.classList.add('ci-fx-msg'); setTimeout(function () { msg.classList.remove('ci-fx-msg'); }, 1200); }
    burst(band, ship ? ['#7CBBBB', '#1D7A49', '#F3845D', '#F6C35B'] : ['#F3845D', '#E8A0B4', '#F6C35B', '#7CBBBB'], cur.pct);
  }
  function highlightGiftLine() {
    if (Date.now() > fx.hlUntil || reducedMotion()) return;
    var li = host() && host().querySelector('.mini-cart .ci-gift-line');
    if (!li || li.classList.contains('ci-fx-hl')) return;
    fx.hlUntil = 0;
    li.classList.add('ci-fx-hl');
    setTimeout(function () { li.classList.remove('ci-fx-hl'); }, 700);
  }
  function fxRender(e) {
    try {
      if (!enabled()) return;
      var cur = fxState();
      if (!cur) return;
      var prev = fx.prev;
      fx.prev = cur;
      var mutated = e && (e.type === 'ci:cart:rerendered' || e.type === 'cart:updated');
      if (!prev || !mutated) return;                     /* load, drawer open and toggles only record */
      var h = host(), band = h.querySelector('.free-shipping');
      var now = Date.now();
      if (!reducedMotion()) {
        if (Math.abs(prev.pct - cur.pct) > .1) runTween(band, prev, cur);
        if (prev.kind === cur.kind && cur.kind !== 'ok' && prev.gap > cur.gap) runCountdown(band, prev, cur);
      }
      var which = [];
      if (prev.kind !== 'ok' && cur.kind === 'ok') {
        which.push('ship');   /* 2026-10-13 (Ondrej): every upward crossing celebrates, no session cap or cooldown */
      } else if (prev.kind === 'ok' && cur.kind !== 'ok') fx.downAt.ship = now;
      if (cur.over === false && prev.over === true) { fx.downAt.gift = now; fx.giftPending = 0; }
      if (prev.over === false && cur.over === true) fx.giftPending = now;
      if (fx.giftPending && cur.off) fx.giftPending = 0;
      if (fx.giftPending && cur.line && cur.free) {
        fx.giftPending = 0;
        which.push('gift');
      }
      if (which.length) unlockMoment(band, cur, which);
      highlightGiftLine();
    } catch (err) {}
  }
  document.addEventListener('ci:cart:rerendered', fxRender);
  document.addEventListener('cart:updated', fxRender);
  document.addEventListener('cartdrawer:opened', fxRender);
  document.addEventListener('toggle', function (e) {
    var det = e.target;
    if (det && det.classList && det.classList.contains('cart-drawer-container')) fxRender(e);
  }, true);
  setTimeout(function () { if (!fx.prev) { try { fx.prev = fxState(); } catch (e) {} } }, 0);

  /* ---------- the shopper removes the gift line herself = declined (window capture: runs before the drawer's
     own remove handler, which stops propagation) ---------- */
  window.addEventListener('click', function (ev) {
    try {
      var t = ev.target;
      var rm = t && t.closest && t.closest('.mini-cart .ci-gift-line cart-remove-button');
      /* 2026-10-16: the /cart gift row's remove counts as declined too, so the cart page auto-add never re-adds it */
      var rmPage = !rm && t && t.closest && t.closest('tr[data-ci-gift-row] cart-remove-button');
      if (!rm && !rmPage) return;
      ss(K.declined, '1');
      var S = readState(), g = S && S.gl && S.gl.length ? giftByPid(S, S.gl[0].pid) : null;
      track('ci_gift_removed', { ci_gift: g ? g.h : '', ci_via: rmPage ? 'shopper_cart_page' : 'shopper' });
    } catch (e) {}
  }, true);

  /* ---------- the gift sheet (picks sheet component, gift body) ---------- */
  function el(tag, cls, html) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (html != null) n.innerHTML = html;
    return n;
  }
  function pickTiles() {
    var out = [], h = host();
    if (!h) return out;
    var lis = h.querySelectorAll('cart-recommendations li[data-ci-disc-product]');
    for (var i = 0; i < lis.length; i++) {
      var li = lis[i], im = li.querySelector('img'), tt = li.querySelector('.product-title');
      var price = parseInt(li.getAttribute('data-ci-price'), 10) || 0;
      if (!price || !li.querySelector('add-to-cart.ci-rec-add')) continue;
      out.push({ pid: li.getAttribute('data-ci-disc-product'), title: (tt && tt.textContent || '').trim(),
        price: price, compare: parseInt(li.getAttribute('data-ci-compare'), 10) || 0, img: im ? (im.currentSrc || im.src) : '' });
    }
    return out;
  }
  function rowHTML(S, o) {
    return '<span class="ci-gs-th"><img src="' + esc(o.img) + '" alt="" width="46" height="46" loading="lazy"></span>' +
      '<span class="ci-gs-rb"><span class="ci-gs-rn">' + esc(o.name) + '</span><span class="ci-gs-rp">' + o.prices + '</span></span>';
  }
  function buildSheetBody(S, g, state) {
    var frag = document.createDocumentFragment();
    var h = host();
    var tpl = h && h.querySelector('template[data-ci-gift-tpl="' + g.pid + '"]');
    var tplFrag = tpl ? tpl.content.cloneNode(true) : null;
    var gal = tplFrag && tplFrag.querySelector('.ci-pick-sheet__gallery');
    if (gal) frag.appendChild(gal);

    /* price row: struck value + FREE (or the real price while the discount is not live) + tag */
    var free = S.free === 1 || (S.gl.length && S.gl[0].p === 0);
    var pr = el('div', 'ci-pick-sheet__price ci-gs-price');
    var priceNow = S.gl.length ? S.gl[0].p : (state === 'declined' ? g.p : 0);
    if (g.s > priceNow) pr.appendChild(el('s', 'ci-pick-sheet__was', esc(money(S, g.s))));
    if ((state === 'unlocked' || state === 'declined') && !free) pr.appendChild(el('span', 'ci-pick-sheet__sale ci-pick-sheet__sale--plain', esc(money(S, priceNow))));
    else pr.appendChild(el('span', 'ci-gs-free', 'FREE'));
    pr.appendChild(el('span', 'ci-gs-tag', state === 'locked' ? 'at ' + esc(S.thl) : 'Your gift'));
    frag.appendChild(pr);

    /* locked: how far she is + the picks that close the gap */
    if (state === 'locked') {
      var gap = Math.max(0, S.th - S.q);
      var box = el('div', 'ci-gs-unl');
      box.appendChild(el('p', 'ci-gs-unm', 'Add <b>' + esc(money(S, gap, true)) + '</b> more to get it free'));
      var pct = Math.max(0, Math.min(100, S.q / S.fs * 100)).toFixed(1);
      box.appendChild(el('div', 'ci-gs-trk', '<span class="ci-gs-fl" style="width:' + pct + '%"></span><span class="ci-gs-knob" style="left:' + pct + '%"></span>'));
      var tiles = pickTiles();
      if (tiles.length) {
        /* automatic discounts (35% bracelet sale, qty tiers) lower final_line_price, so judge a pick by its price after the deepest discount seen on the cart */
        var dmax = 0;
        (S.lines || []).forEach(function (ln) { if (ln.o > 0 && ln.c < ln.o) dmax = Math.max(dmax, 1 - ln.c / ln.o); });
        dmax = Math.min(dmax, 0.6);
        var cover = tiles.filter(function (t) { return Math.floor(t.price * (1 - dmax)) >= gap; }).slice(0, 2);
        var heading = 'Any of these unlocks it';
        if (!cover.length) { cover = tiles.slice(0, 2); heading = 'Add one of these to get closer'; }
        box.appendChild(el('p', 'ci-gs-unh', heading));
        var ul = el('ul', 'ci-gs-urows');
        cover.forEach(function (t) {
          var li = el('li', 'ci-gs-ur', rowHTML(S, { img: t.img, name: t.title,
            prices: (t.compare > t.price ? '<s>' + esc(money(S, t.compare)) + '</s>' : '') + '<i>' + esc(money(S, t.price)) + '</i>' }));
          var b = el('button', 'ci-gs-uadd', 'Add');
          b.type = 'button';
          b.setAttribute('data-ci-gift-unlock', t.pid);
          li.appendChild(b);
          ul.appendChild(li);
        });
        box.appendChild(ul);
      }
      frag.appendChild(box);
    }

    /* why this gift: the one or two cart products that pushed its score */
    var R = window.__ciGiftRank || {}, contrib = [];
    S.lines.forEach(function (l, i) {
      var r = R[l.pid], v = r && r[g.pid] ? r[g.pid] * weight(i) : 0;
      if (v > 0) contrib.push({ t: l.t, v: v });
    });
    contrib.sort(function (a, b) { return b.v - a.v; });
    contrib = contrib.slice(0, 2);
    if (contrib.length) {
      var names = contrib.map(function (c) { return short(c.t); });
      frag.appendChild(el('p', 'ci-gs-why', 'Picked for your cart: people who buy ' + esc(names.join(' and ')) + ' often add ' + esc(short(g.t)) + '.'));
    }

    /* description (heading, clamped text, Read more) from the template */
    if (tplFrag) frag.appendChild(tplFrag);

    return frag;
  }
  function openGiftSheet(source, trigger) {
    var api = window.__ciSheetApi, S = readState();
    if (!api || !S || !S.en) return;
    var g = chooseGift(S);
    if (!g) return;
    var state = S.gl.length ? 'unlocked' : (S.q >= S.th ? 'declined' : 'locked');
    var free = S.free === 1 || (S.gl.length && S.gl[0].p === 0);
    var footer = state === 'unlocked' ? { type: 'ghost', text: free ? 'In your cart · Free' : 'In your cart' }
      : state === 'declined' ? { type: 'add', text: 'Add to cart' + (free ? ' · Free' : '') } : { type: 'none' };
    var node = api.open({ title: g.t, body: buildSheetBody(S, g, state), footer: footer, cls: 'ci-gift-sheet ci-gift-sheet--' + state, trigger: trigger });
    if (!node) return;
    track('ci_gift_open', { ci_source: source, ci_state: state === 'locked' ? 'locked' : 'unlocked', ci_gift: g.h });
    node.addEventListener('click', function (ev) {
      var t = ev.target;
      if (!t || !t.closest) return;
      var un = t.closest('[data-ci-gift-unlock]');
      if (un) { ev.preventDefault(); addPick(un.getAttribute('data-ci-gift-unlock'), un); return; }
      if (t.closest('[data-ci-gift-sheet-add]')) {
        ev.preventDefault();
        api.close();
        var S2 = readState() || S;
        addGift(chooseGift(S2), 'declined_card');
      }
    });
  }
  /* an unlock row's ADD is the strip tile's own add-to-cart (optimistic paint, ci_rec_add and all), posted with
     _upsell_path = gift_sheet for the duration of the click, exactly like the picks sheet does with "info". */
  function addPick(pid, btn) {
    var h = host();
    var tile = h && h.querySelector('cart-recommendations li[data-ci-disc-product="' + pid + '"] add-to-cart.ci-rec-add');
    track('ci_gift_unlock_add', { ci_pick: pid });
    if (tile && !tile.hasAttribute('disabled')) {
      var prev = tile.getAttribute('data-properties'), p = {};
      try { p = JSON.parse(prev || '{}') || {}; } catch (e) { p = {}; }
      p._upsell_path = 'gift_sheet';
      try { tile.setAttribute('data-properties', JSON.stringify(p)); tile.click(); }
      finally { if (prev === null) tile.removeAttribute('data-properties'); else tile.setAttribute('data-properties', prev); }
    }
    if (btn) { btn.textContent = 'Added'; btn.disabled = true; btn.classList.add('is-added'); }
    setTimeout(function () { var api = window.__ciSheetApi; if (api && api.alive()) api.close(); }, 600);
  }

  /* ---------- opening: marker, card, gift line (capture so the links never navigate) ---------- */
  document.addEventListener('click', function (ev) {
    try {
      var t = ev.target;
      if (!t || !t.closest) return;
      var h = host();
      var add = t.closest('[data-ci-gift-add]');
      if (add && h && h.contains(add)) {
        ev.preventDefault();
        var S = readState();
        if (S && S.en) addGift(chooseGift(S), 'declined_card');
        return;
      }
      var op = t.closest('[data-ci-gift-open]');
      if (!op || !h || !h.contains(op)) return;
      ev.preventDefault();
      openGiftSheet(op.getAttribute('data-ci-gift-open'), op);
    } catch (e) {}
  }, true);
  document.addEventListener('keydown', function (ev) {
    try {
      if (ev.key !== 'Enter' && ev.key !== ' ') return;
      var t = ev.target;
      if (!t || !t.matches || !t.matches('.ci-gc[data-ci-gift-open]')) return;
      if (t.getAttribute('data-mode') === 'declined') return;
      ev.preventDefault();
      openGiftSheet('card', t);
    } catch (e) {}
  }, true);
})();


/* ---------- OneText SMS popup waits for the cart drawer (2026-10-13, Ondrej) ----------
   "not to send people away from the drawer": the OneText popup is a MODAL <dialog> inside
   body > #ot-popup-shadow-container, opened with showModal(). While the cart drawer is open that call is held
   and replayed once the drawer closes, so the popup opens as usual, just later; a shopper who goes from the
   drawer to checkout never sees it. Never hide an open modal instead: a hidden modal leaves the page inert
   (the 06:17-07:12Z freeze on the gift arm). Events: ci_ot_popup_deferred, ci_ot_popup_released. */
(function () {
  var D = window.HTMLDialogElement && window.HTMLDialogElement.prototype;
  if (!D || typeof D.showModal !== 'function' || D.__ciOtDefer) return;
  var orig = D.showModal;
  var held = null;
  function drawerOpen() { return !!document.querySelector('details.cart-drawer-container[open]'); }
  function isOneText(dl) {
    try { var r = dl.getRootNode(); return !!(r && r.host && r.host.id === 'ot-popup-shadow-container'); } catch (e) { return false; }
  }
  function track(n) { try { if (window.__ciTrack) window.__ciTrack(n, {}); } catch (e) {} }
  D.showModal = function () {
    if (isOneText(this) && drawerOpen()) {
      if (held !== this) track('ci_ot_popup_deferred');
      held = this;
      return;
    }
    return orig.apply(this, arguments);
  };
  D.__ciOtDefer = true;
  function release() {
    if (!held || drawerOpen()) return;
    var dl = held;
    setTimeout(function () {
      if (held !== dl || drawerOpen()) return;   /* reopened meanwhile: keep holding */
      held = null;
      if (!dl.isConnected || dl.open) return;     /* OneText dropped or already showed it */
      try { orig.call(dl); track('ci_ot_popup_released'); } catch (e) {}
    }, 600);
  }
  /* the drawer is a <details>; toggle does not bubble, so listen in the capture phase */
  document.addEventListener('toggle', function (e) {
    var t = e.target;
    if (t && t.classList && t.classList.contains('cart-drawer-container')) release();
  }, true);
})();


/* ---------- threshold reach tracking (2026-10-13, Ondrej: "do we measure every reach of gift/free shipping") ----------
   Identical on MAIN and every cart arm, so the arms compare like for like: ci_tier_up / ci_tier_down with ci_tier
   'gift' ($58.85) or 'ship' ($78.85), on EVERY crossing caused by a cart change in this page (the first cart seen is
   only the baseline, so a page load never fires). USD carts only: the test is US-only and the thresholds are USD.
   Totals are the drawer's qualifying subtotal; every read is also broadcast as document event ci:cart:qual.
   Reads the cart JSON the theme already fetches (passive read of /cart.js, /cart/change, /cart/update, /cart/clear
   responses; /cart/add returns a line, not a cart, so it is skipped) and, if a cart change brings no cart JSON with
   it, makes one /cart.js call of its own. Intelligems gets these through the ciTrackBridge event. */
(function () {
  if (window.__ciTierTrack || typeof window.fetch !== 'function') return;
  window.__ciTierTrack = 1;
  var TIERS = [['gift', 5885], ['ship', 7885]];
  var CART_URL = /\/cart(\.js|\/(change|update|clear)(\.js)?)(\?|$)/;
  var last = null, seenAt = 0, timer = 0;
  function track(n, p) { try { if (window.__ciTrack) window.__ciTrack(n, p); } catch (e) {} }
  /* qualifying subtotal = the drawer bar's: non-gift lines' final_line_price (a gift line is any line with
     properties._ci_gift; control has none), so a briefly charged gift line never counts */
  function qual(c) {
    var s = 0;
    for (var i = 0; i < c.items.length; i++) {
      var it = c.items[i];
      if (it.properties && it.properties._ci_gift) continue;
      s += it.final_line_price || 0;
    }
    return s;
  }
  function take(c) {
    if (!c || typeof c.total_price !== 'number' || !c.items) return;
    seenAt = Date.now();
    var t = qual(c);
    try { document.dispatchEvent(new CustomEvent('ci:cart:qual', { detail: { cents: t, currency: c.currency || '' } })); } catch (e) {}
    if (c.currency && c.currency !== 'USD') { last = null; return; }
    if (last !== null && t !== last) {
      for (var i = 0; i < TIERS.length; i++) {
        var k = TIERS[i][0], v = TIERS[i][1];
        if (last < v && t >= v) track('ci_tier_up', { ci_tier: k, ci_total: t / 100 });
        else if (last >= v && t < v) track('ci_tier_down', { ci_tier: k, ci_total: t / 100 });
      }
    }
    last = t;
  }
  var origFetch = window.fetch;
  window.fetch = function (input) {
    var p = origFetch.apply(this, arguments);
    try {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      if (CART_URL.test(url)) {
        p.then(function (res) {
          try { if (res && res.ok) res.clone().json().then(take, function () {}); } catch (e) {}
        }, function () {});
      }
    } catch (e) {}
    return p;
  };
  function changed() {
    var at = Date.now();
    clearTimeout(timer);
    timer = setTimeout(function () {
      if (seenAt >= at) return;                       /* the change already brought its cart JSON */
      origFetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(take, function () {});
    }, 700);
  }
  document.addEventListener('ci:cart:rerendered', changed);
  document.addEventListener('cart:updated', changed);
  /* baseline if the theme has not read the cart by then */
  setTimeout(function () {
    if (last === null && !seenAt) origFetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(take, function () {});
  }, 4000);
})();


/* ---------- gift arm: cart tier class for the top bar and PDP ship lines (2026-10-13) ----------
   snippets/ci-tier prints html.ci-tiers + ci-tier-0/1/2 on load (US carts in USD with the gift on); this keeps it
   current after cart changes from the tracker's ci:cart:qual event. CSS in ci-native-cart.css shows the matching
   message (bar slide, PDP truck line, PDP ship rows). */
(function () {
  document.addEventListener('ci:cart:qual', function (e) {
    var h = document.documentElement, d = e.detail || {};
    if (!h.classList.contains('ci-tiers') || (d.currency && d.currency !== 'USD')) return;
    var n = d.cents >= 7885 ? 2 : (d.cents >= 5885 ? 1 : 0);
    if (h.classList.contains('ci-tier-' + n)) return;
    h.classList.remove('ci-tier-0', 'ci-tier-1', 'ci-tier-2');
    h.classList.add('ci-tier-' + n);
  });
})();


/* ---------- gift arm: gift promo surfaces (2026-10-13) ----------
   Drives three storefront surfaces outside the drawer, all gated on html.ci-tiers (US carts in USD with the gift on;
   snippets/ci-tier prints the class, so everyone else gets none of this):
   - PDP gift line under Add to cart (snippets/buy-buttons.liquid, [data-ci-pdp-gift]): base / cross toward the gift, then
     ship / shipCross / done toward free shipping (once the gift is unlocked the same line promotes free shipping)
   - collection progress strip (sections/main-collection-product-grid.liquid, [data-ci-promo-strip])
   - "Unlocks free gift" / "Unlocks free shipping" tags on collection cards (.ci-unlock-badge) and drawer picks
     (li.ci-unlock-tag parent): gift mode under the gift line, ship mode between the gift line and free shipping
   q = qualifying subtotal in cents: <html data-ci-q> on load, then the ci:cart:qual event. Gift candidates come from
   #ci-gift-promo (snippets/ci-gift-promo-data.liquid). The chosen gift is the drawer's own sessionStorage key
   ci_gift_choice (product id); the PDP line writes it only when no gift is chosen yet, so the drawer shows the same
   gift. Read only everywhere else: no listener on the product form or its buttons, no MutationObserver, and the only
   timer is the bounded 3s wait for the drawer's gift card. */
(function () {
  'use strict';
  var root = document.documentElement;
  if (!root.classList.contains('ci-tiers')) return;
  var GIFT = 5885, SHIP = 7885, CHOICE = 'ci_gift_choice';
  var q = parseInt(root.getAttribute('data-ci-q'), 10) || 0;
  var cands = [];
  var seen = {};
  var lineP = 0, lineAvail = true;
  var pollTimer = 0;

  try {
    var node = document.getElementById('ci-gift-promo');
    var arr = node ? JSON.parse(node.textContent) : [];
    for (var ci = 0; ci < arr.length; ci++) {
      if (arr[ci] && Number(arr[ci].a) === 1) cands.push(arr[ci]);
    }
  } catch (e) { cands = []; }

  function track(name, params) { try { if (window.__ciTrack) window.__ciTrack(name, params); } catch (e) {} }
  function once(key, name, params) {
    if (seen[key]) return;
    seen[key] = 1;
    track(name, params);
  }
  function esc(s) { return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }
  function chosenPid() {
    try { return sessionStorage.getItem(CHOICE); } catch (e) { return null; }
  }
  function knownGift() {
    var c = chosenPid();
    if (c === null || c === '') return null;
    for (var i = 0; i < cands.length; i++) {
      if (String(cands[i].pid) === String(c)) return cands[i];
    }
    return null;
  }
  function drawerIsOpen() { return !!document.querySelector('details.cart-drawer-container[open]'); }
  function makeTappable(el, on) {
    if (on) {
      if (el.getAttribute('role') !== 'button') el.setAttribute('role', 'button');
      if (el.getAttribute('tabindex') !== '0') el.setAttribute('tabindex', '0');
    } else {
      el.removeAttribute('role');
      el.removeAttribute('tabindex');
    }
  }
  function openDrawer() {
    var mc = document.querySelector('mini-cart');
    try { if (mc && typeof mc.open === 'function') mc.open(); } catch (e) {}
    return mc;
  }
  function openDrawerThenGiftSheet() {
    openDrawer();
    clearInterval(pollTimer);
    var n = 0;
    pollTimer = setInterval(function () {
      n++;
      var card = document.querySelector('#mini-cart [data-ci-gift-open="card"]');
      if (card) {
        clearInterval(pollTimer);
        try { card.click(); } catch (e) {}
      } else if (n >= 30) {
        clearInterval(pollTimer);
      }
    }, 100);
  }

  /* PDP gift: the drawer's chosen gift; if none yet, the candidate with the best co-purchase score for this product
     (never the product itself) and remember it so the drawer shows the same gift. If the chosen gift is this very
     product, show the next best without touching the stored choice. */
  function pdpGift(pdpPid) {
    var k = knownGift();
    if (k && String(k.pid) !== String(pdpPid)) return k;
    var rank = (window.__ciGiftRank && window.__ciGiftRank[pdpPid]) || {};
    var best = null, bestScore = -1;
    for (var i = 0; i < cands.length; i++) {
      if (String(cands[i].pid) === String(pdpPid)) continue;
      var s = Number(rank[cands[i].pid]) || 0;
      if (s > bestScore) { best = cands[i]; bestScore = s; }
    }
    if (best && !k) {
      try { sessionStorage.setItem(CHOICE, String(best.pid)); } catch (e) {}
    }
    return best;
  }

  /* ---- PDP line ---- */
  var line = document.querySelector('[data-ci-pdp-gift]');
  var lineState = '';
  if (line) {
    lineP = parseInt(line.getAttribute('data-ci-price'), 10) || 0;
    lineAvail = line.getAttribute('data-ci-avail') === '1';
  }
  function renderLine() {
    if (!line) return;
    var g = pdpGift(line.getAttribute('data-ci-pid'));
    if (!g) { line.hidden = true; return; }
    var state, html;
    if (q >= SHIP) state = 'done';
    else if (q >= GIFT) state = (lineAvail && q + lineP >= SHIP) ? 'shipCross' : 'ship';
    else state = (lineAvail && q + lineP >= GIFT) ? 'cross' : 'base';
    if (state === 'done') html = 'Free <b>' + esc(g.t) + '</b> + free shipping unlocked';
    else if (state === 'shipCross') html = 'Gift unlocked! Add this for <b>free shipping</b>';
    else if (state === 'ship') html = 'Free <b>' + esc(g.t) + '</b> unlocked! <b>$' + Math.ceil((SHIP - q) / 100) + '</b> away from free shipping';
    else if (state === 'cross') html = 'Add this and your free <b>' + esc(String(g.k).toLowerCase()) + '</b> is unlocked';
    else html = 'Free <b>' + esc(g.t) + '</b> with orders $59+';
    var txt = line.querySelector('.ci-pdp-gift__text');
    if (txt && txt.innerHTML !== html) txt.innerHTML = html;
    var img = line.querySelector('.ci-pdp-gift__img');
    if (img && g.i && img.getAttribute('src') !== g.i) img.setAttribute('src', g.i);
    line.classList.toggle('is-unlocked', state === 'ship' || state === 'shipCross' || state === 'done');
    line.classList.toggle('is-cross', state === 'cross' || state === 'shipCross');
    makeTappable(line, q > 0);
    line.hidden = false;
    lineState = state;
    once('line:' + state, 'ci_promo_line_view', { ci_state: state, ci_gift: g.pid });
  }
  function onLineTap(ev) {
    if (!line || q <= 0 || line.getAttribute('role') !== 'button') return;
    if (ev && ev.type === 'keydown') {
      if (ev.key !== 'Enter' && ev.key !== ' ') return;
      ev.preventDefault();
    }
    track('ci_promo_line_tap', { ci_state: lineState });
    openDrawerThenGiftSheet();
  }
  if (line) {
    line.addEventListener('click', onLineTap);
    line.addEventListener('keydown', onLineTap);
  }

  /* ---- collection strip ---- */
  var strip = document.querySelector('[data-ci-promo-strip]');
  var stripState = '';
  function renderStrip() {
    if (!strip) return;
    var state, html, pct = 0;
    if (q <= 0) { state = 'empty'; html = '🎁 Free gift on orders $59+'; }
    else if (q < GIFT) { state = 'toGift'; html = 'You\'re <b>$' + Math.ceil((GIFT - q) / 100) + '</b> away from a free gift'; pct = q / GIFT * 100; }
    else if (q < SHIP) { state = 'toShip'; html = 'Gift unlocked! <b>$' + Math.ceil((SHIP - q) / 100) + '</b> away from free shipping'; pct = q / SHIP * 100; }
    else { state = 'done'; html = '🎉 Free gift + free shipping unlocked'; }
    var txt = strip.querySelector('.ci-promo-strip__text');
    if (txt && txt.innerHTML !== html) txt.innerHTML = html;
    var trackEl = strip.querySelector('.ci-promo-strip__track');
    var fill = strip.querySelector('.ci-promo-strip__fill');
    var showTrack = state === 'toGift' || state === 'toShip';
    if (trackEl) trackEl.hidden = !showTrack;
    if (fill) fill.style.width = Math.max(0, Math.min(100, pct)) + '%';
    strip.classList.toggle('is-gift', state === 'toGift');
    strip.classList.toggle('is-ship', state === 'toShip');
    var img = strip.querySelector('.ci-promo-strip__img');
    var g = knownGift();
    if (img) {
      if (g && g.i) {
        if (img.getAttribute('src') !== g.i) img.setAttribute('src', g.i);
        img.hidden = false;
      } else {
        img.hidden = true;
      }
    }
    makeTappable(strip, q > 0);
    strip.hidden = false;
    stripState = state;
    once('strip:' + state, 'ci_promo_strip_view', { ci_state: state });
  }
  function onStripTap(ev) {
    if (!strip || q <= 0 || strip.getAttribute('role') !== 'button') return;
    if (ev && ev.type === 'keydown') {
      if (ev.key !== 'Enter' && ev.key !== ' ') return;
      ev.preventDefault();
    }
    track('ci_promo_strip_tap', { ci_state: stripState });
    openDrawer();
  }
  if (strip) {
    strip.addEventListener('click', onStripTap);
    strip.addEventListener('keydown', onStripTap);
  }

  /* ---- unlock tags: a card or pick qualifies when it lifts the cart over the next line. 'gift' mode: under the gift
     line and this price reaches it; 'ship' mode: gift unlocked, under free shipping and this price reaches it ---- */
  function tagMode(price) {
    if (price <= 0) return '';
    if (q < GIFT) return q + price >= GIFT ? 'gift' : '';
    if (q < SHIP) return q + price >= SHIP ? 'ship' : '';
    return '';
  }
  function renderTags() {
    var i, price, el, mode, gridN = 0, gridMode = '';
    var badges = document.querySelectorAll('.ci-unlock-badge');
    for (i = 0; i < badges.length; i++) {
      el = badges[i];
      if (el.closest('#mini-cart')) continue;
      price = parseInt(el.getAttribute('data-ci-unlock-price'), 10) || 0;
      mode = el.hasAttribute('data-ci-unlock-off') ? '' : tagMode(price);
      el.classList.toggle('is-on', mode !== '');
      el.classList.toggle('is-gift', mode === 'gift');
      el.classList.toggle('is-ship', mode === 'ship');
      if (mode) { gridN++; gridMode = mode; }
    }
    if (gridN > 0) once('tag:grid:' + gridMode + ':' + gridN, 'ci_unlock_tag_view', { ci_where: 'grid', ci_count: gridN, ci_mode: gridMode });
    var lis = document.querySelectorAll('#mini-cart li[data-ci-price]');
    var drawerN = 0, drawerMode = '';
    for (i = 0; i < lis.length; i++) {
      price = parseInt(lis[i].getAttribute('data-ci-price'), 10) || 0;
      mode = tagMode(price);
      lis[i].classList.remove('ci-unlocks', 'ci-unlocks--gift', 'ci-unlocks--ship');
      if (mode) {
        lis[i].classList.add('ci-unlocks', 'ci-unlocks--' + mode);
        drawerN++; drawerMode = mode;
      }
    }
    if (drawerN > 0 && drawerIsOpen()) once('tag:drawer:' + drawerMode + ':' + drawerN, 'ci_unlock_tag_view', { ci_where: 'drawer', ci_count: drawerN, ci_mode: drawerMode });
  }

  function renderAll() {
    try { renderLine(); } catch (e) {}
    try { renderStrip(); } catch (e) {}
    try { renderTags(); } catch (e) {}
  }

  /* ---- unlock tag clicks (read only: never prevents or stops anything) ---- */
  window.addEventListener('click', function (e) {
    try {
      var t = e.target;
      if (!t || !t.closest) return;
      var li = t.closest('li.ci-unlocks');
      if (li) {
        track('ci_unlock_tag_click', { ci_where: 'drawer', ci_product: li.getAttribute('data-ci-disc-product') || '', ci_mode: li.classList.contains('ci-unlocks--ship') ? 'ship' : 'gift' });
        return;
      }
      var w = t.closest('.card-wrapper');
      var ub = w && w.querySelector('.ci-unlock-badge.is-on');
      if (ub) {
        var a = w.querySelector('a[href*="/products/"]');
        var m = a && /\/products\/([^/?#]+)/.exec(a.getAttribute('href') || '');
        track('ci_unlock_tag_click', { ci_where: 'grid', ci_product: m ? m[1] : '', ci_mode: ub.classList.contains('is-ship') ? 'ship' : 'gift' });
      }
    } catch (err) {}
  }, true);

  /* ---- refresh triggers ---- */
  document.addEventListener('ci:cart:qual', function (e) {
    var d = e.detail || {};
    if (d.currency && d.currency !== 'USD') return;
    q = Math.max(0, parseInt(d.cents, 10) || 0);
    renderAll();
  });
  document.addEventListener('ci:recs:set', renderAll);
  document.addEventListener('ci:cart:rerendered', function () { setTimeout(renderAll, 0); });
  /* the drawer's picks are already in the page when it opens: refresh then so the drawer tag view counts an open drawer */
  document.addEventListener('toggle', function (e) {
    var t = e.target;
    if (t && t.matches && t.matches('details.cart-drawer-container')) setTimeout(renderAll, 0);
  }, true);
  try {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
        try {
          var v = event && event.data && event.data.variant;
          if (v) {
            lineP = parseInt(v.price, 10) || 0;
            lineAvail = !!v.available;
          }
        } catch (e) {}
        renderLine();
      });
    }
  } catch (e) {}

  renderAll();
})();
